/* tslint:disable:object-literal-sort-keys */

export const messages = {
    "en": {
      allItemDisplayList: {
        futureLocation: "Future location:",
      },
      "countryCode": "gb",
      "actionBar": {
        "sideMenu": {
          "confirmDeletion": "Confirm deletion"
        }
      },
      addContainerModal: {
        errors: {
          resultsAmongExcludedIds: "Items already contained will not appear here",
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Your credentials are incorrect",
            "network": "Communication with server failed"
          },
          "form": {
            "password": {
              "error": "Please enter your User ID",
              "label": "Password"
            },
            "submit": "Log in",
            "submitting": "Logging in",
            "username": {
              "error": "Please enter your password",
              "label": "User ID"
            }
          }
        },
        "renew": {
          "slowNetwork": "This is taking a bit longer than usual, please do not log out",
          "spinner": "We are getting you back online"
        }
      },
      "dashboard": {
        "movement": {
          "title": "Latest movements",
          "emptyMessage": "No movement to process"
        },
        "task": {
          "title": "Latest tasks",
          "emptyMessage": "No task to process"
        }
      },
      "entity": {
        "actionMenu": {
          "movement": {
            "addItem": "Add object",
            "cancel": "Cancel movement",
            "close": "Finalize movement",
            "return": "Create return movement",
            "addContainer": "Add container",
            "selectContainer": "Select a container",
            "addAccessory": "Add accessory",
            "delete": "Delete movement",
            "startMovement": "Start the movement"
          },
          "noActions": "No actions available",
          "task": {
            "createComplexMovement": "Create a complex movement",
            "createMovement": "Create a movement from this task",
            "createSimpleMovement": "Create a simple movement",
            "rejectTask": "Replan the task",
            "startTask": "Start the task",
            "terminateTask": "Finalize the task"
          },
          "container": {
            "addItem": "Add object",
            "createContainer": "Create a container",
            "closeContainer": "Close the container",
            "openContainer": "Open the container",
            "addAccessory": "Add accessory",
            "addContainer": "Add container",
            "missingLocation": "Warning: this container does not have a location",
            "addLocation": "Localize the container",
            "delete": "Delete container"
          }
        },
        "addItem": {
          "error": {
            "api": "The object could not be added",
            "network": "Communication with server failed"
          },
          "form": {
            "id": {
              "alreadyAdded": "The object has already been added to this movement",
              "emptyError": "Please scan an object",
              "label": "ID",
              "notFoundError": "Object is unknown"
            },
            "location": {
              "emptyError": "Please select a location",
              "label": "Arrival location",
              "notFoundError": "Location is unknown"
            },
            "submit": "Add",
            "submitting": "Adding"
          },
          "modal": {
            "title": "Add object",
            "shouldChainAdd": "Enable chain adding"
          }
        },
        "cancelMovement": "Do you want to cancel this movement?",
        "closeMovement": {
          "error": {
            "api": "The movement could not be finalized",
            "network": "Communication with server failed",
            "noItemLocation": "Failed to start : at least one item does not have an arrival location",
            "itemsWithoutPermanentLocation": "Please set a permanent location to these items or uncheck the \"{0}\" option.",
            "noDestination": "Failed to start : the movement's arrival location is not set"
          },
          "form": {
            "location": {
              "emptyError": "Please select a location",
              "inputPlaceholder": "Please type a location",
              "label": "Arrival location",
              "noResult": "No result",
              "notFoundError": "Location unknown"
            },
            "permanentLocation": {
              "label": "Change permanent location"
            },
            "submit": "Finalize",
            "submitting": "Finalizing",
            "usePermanentLocItemAsDestination": {
              "label": "Use permanent location as destination"
            }
          },
          "modal": {
            "cannotBeClosed": "The movement current status does not allow for finalization",
            "noItems": "You have not validated any object",
            "title": "Finalize the movement"
          }
        },
        "createMovementFromTask": "Do you want to create a movement based on this task ?",
        "createReturnMovement": "Do you want to create a return movement from this movement?",
        "noItems": "No object is linked",
        "chooseItemModal": {
          "containerMode": "Container",
          "locationMode": "Location",
          "containerHint": "Container",
          "setPermanentLocation": "Set permanent location"
        },
        confirmation: "Confirmation",
        "mapModal": {
          "saveNotification": {
            "locationChanged": "Item location was successfully changed",
            "containerChanged": "Item was successfully added to container",
            "errorMessage": "There was an error applying the modifications",
            "itemAlreadyInContainer": "The item is already inside the container"
          },
          "locationSelector": "Add location",
          "barcodeEditor": "Edit barcode",
          "editBarcode": "Edit",
          "editingBarcode": "Editing",
          "generateBarcodePdf": "Generate PDF",
          "generateBarcodeZpl": "Generate ZPL"
        },
        "itemTypes": {
          "container": "Container",
          "museum": "Item",
          "accessory": "Accessory",
          "film": "Film"
        },
        "openContainersModal": {
          "title": "Open containers",
          "message": "The movement cannot be closed as there are open containers inside:",
          "missingLocation": "Some containers do not have a location they cannot be closed.",
          "closeAll": "Close all containers"
        }
      },
      "entityList": {
        "actionMenu": {
          "movement": {
            "create": "Create a complex movement"
          }
        },
        "container": {
          "deletingConfirmation": "Are you sure you want to delete this container?"
        },
        "movement": {
          "createMovement": "Do you want to create a movement?",
          "featuredEmptyMessage": "No movement found",
          "featuredTitle": "Latest movements",
          "field": {
            "author": "Author",
            "endDate": "End date",
            "startDate": "Request",
            "title": "Title"
          },
          "historyTitle": "Movements history",
          "deletingConfirmation": "Are you sure you want to delete this movement?"
        },
        "task": {
          "featuredEmptyMessage": "No task found",
          "featuredTitle": "Latest tasks",
          "field": {
            "author": "Author",
            "endDate": "End date",
            "startDate": "Request",
            "title": "Title"
          },
          "historyTitle": "Tasks history"
        },
        "seeMore": "See more"
      },
      "firewall": {
        "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
        "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
      },
      "featuredCard": {
        "authorEmpty": "No author",
        "authorError": "Impossible to retrieve the author",
        "dateEmpty": "No date available",
        "descriptionEmpty": "-",
        "headerDateEmpty": "No date available",
        "titleEmpty": "-"
      },
      "itemCard": {
        "detailsNotAvailable": "Details not available",
        "error": "Object cannot be displayed",
        "identifier": "Inventory Number {identifier}",
        "identifierError": "Identification error",
        "location": "Location",
        "locationLabel": "Destination: <strong>{title}</strong>",
        "rollback": "Do you want to reset this object?",
        "unknownLocation": "Unknown",
        "title": "Title",
        "locationSelector": {
          "title": "Select a location",
          "validate": "Choose this location"
        }
      },
      linkedMovementLine: {
        linkToMovement: "Access the movement",
        currentMovement: "Movement in progress",
      },
      "movement": {
        "createModal": {
          "form": {
            "motive": "Reason of movement",
            "motiveMissing": "Select reason of movement",
            "submit": "Create movement",
            "submitting": "Creating movement",
            "title": "Title of movement",
            "titleMissing": "Enter title of movement"
          },
          "title": "New movement"
        },
        "entity": {
          "associatedTask": "Linked task:",
          "empty": "This movement does not have any linked objects"
        },
        "featuredList": {
          "emptyMessage": "No movement available",
          "title": "Movements"
        },
        "history": {
          "emptyMessage": "No saved movement",
          "title": "History of movements"
        },
        "itemCard": {
          "arrivalLocation": "Location",
          "identifier": "Inventory number",
          "identifierError": "Identification error",
          "locationHint": "Usual location",
          "permanentLocation": "Permanent location",
          "revertButton": "Cancel",
          "revertPrompt": "Are you sure to reinitiate this object?",
          "revertingButton": "Cancelling",
          "state": {
            "finalized": "This item has been delivered",
            "inTransit": "This item is in transit"
          },
          "deletingConfirmation": "Are you sure you want to delete this object?",
          futureLocation: "Future location:",
        },
        "state": {
          "archived": "Archived",
          "canceled": "Canceled",
          "finalized": "Completed",
          "inPreparation": "In preparation",
          "inProgress": "In progress",
          "programmed": "Planned"
        },
        "items": "Objects",
        "containers": "Containers",
        "accessories": "Accessories",
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Containers already in the movement will not appear here",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Items already in the movement will not appear here",
          }
        },
      },
      movementItemCard: {
        futureLocation: "Planned permanent location of object",
      },
      "container": {
        alerts: {
          containerOpened: 'Container opened !',
          containerClosed: 'Container closed !',
          errors: {
            identificationNumberAlreadyAttributed: "The inventory number is already assigned",
          },
        },
        "createModal": {
          "title": "New container",
          "form": {
            "identifier": "Identifier",
            itemType: 'Type of item',
            "name": "Name",
            "location": "Location",
            "chooseLocation": "Choose location",
            "submit": "Create container"
          }
        },
        "itemCard": {
          "deletingConfirmation": "Do you want to remove this item from the container?"
        },
        "featuredList": {
          "openContainers": {
            "title": "Open containers",
            "emptyMessage": "No open containers"
          },
          "closedContainers": {
            "title": "Closed containers",
            "emptyMessage": "No closed containers"
          }
        },
        "containers": "Containers",
        "items": "Items",
        "accessories": "Accessories",
        validationErrors: {
          identificationNumberAlreadyAttributed: "Value already assigned",
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Containers already in the container will not appear here",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Items already in the container will not appear here",
          }
        },
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Deployed on",
          "checkForUpdate": {
            "help": "If an update is available, it will automatically be installed",
            "title": "Please check updates"
          },
          "clearCache": {
            "help": "If you are offline, it will block the access to all the data stored in the device",
            "title": "Empty cache"
          },
          "overrideLocale": {
            "help": "English language will be used, overriding your device settings",
            "title": "Override locale with ENGLISH"
          },
          "resetLocaleOverride": {
            "help": "Your device language settings will be used to set the application language",
            "title": "Reset locale override"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Do you want to log out?"
      },
      "offlineRibbon": {
        "offline": "You are now logged out"
      },
      "proxy": {
        "error": {
          "default": "An error occurred on the resource",
          "network": "Communication with server failed",
          "notFound": "Resource not found",
          "tokenHasExpired": "Session has expired"
        }
      },
      selectItemMultipleForm: {
        errors: {
          resultsAmongExcludedIds: "Items already contained will not appear here",
        },
      },
      "serviceWorker": {
        "updateAvailable": "An update has been installed. Please click here to refresh the page or restart the application"
      },
      "task": {
        "entity": {
          "commentEditorPlaceholder": "Type comments here...",
          "comments": "Comments",
          "empty": "There is no item associated to this task",
          "hasPendingMovement": "Movement creation in progress...",
          "comment": {
            "save": "Save"
          }
        },
        "featuredList": {
          "emptyMessage": "No task available",
          "title": "Tasks"
        },
        "history": {
          "emptyMessage": "No archived tasks",
          "title": "Tasks history"
        },
        "state": {
          "finalized": "Finalized",
          "inProgress": "In progress",
          "planned": "Planned"
        }
      },
      "entityHistory": {
        "field": {
          "author": "Author",
          "date": "Closing",
          "description": "Title",
          "title": "#"
        }
      },
      "advanceTask": {
        "modal": {
          "title": "Advance task",
          "startTask": "Are you sure you wish to start this task?",
          "terminateTask": "Are you sure you wish to finalize this task?",
          "replanTask": "Are you sure you wish to replan this task?"
        }
      },
      "searchFeaturedCard": {
        "institutionLabel": "Institution"
      }
    },
    fr: {
        allItemDisplayList: {
          futureLocation: "Future localisation :",
        },
        actionBar: {
            sideMenu: {
                confirmDeletion: "Confirmer la suppression",
            }
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Les éléments déjà contenus n'apparaîtront pas ici.",
          },
        },
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe',
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur",
                    },
                },
            },
            renew: {
                slowNetwork:
                    "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...',
            },
        },
        dashboard: {
            movement: { title: 'Derniers mouvements', emptyMessage: 'Aucun mouvement' },
            task: { title: 'Dernières tâches', emptyMessage: 'Aucune tâche' },
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Ajouter un objet',
                    cancel: 'Annuler le mouvement',
                    close: 'Clôturer le mouvement',
                    return: 'Créer un mouvement retour',
                    startMovement: 'Lancer le mouvement',
                    addContainer: 'Ajouter un contenant',
                    selectContainer: 'Sélectionner un contenant',
                    addAccessory: 'Ajouter un accessoire',
                    delete: 'Supprimer le mouvement',
                },
                noActions: 'Aucune action possible',
                task: {
                    createComplexMovement: 'Créer un mouvement complexe',
                    createMovement: 'Créer un mouvement depuis cette tâche',
                    createSimpleMovement: 'Créer un mouvement simple',
                    rejectTask: 'Replanifier la tâche',
                    startTask: 'Démarrer la tâche',
                    terminateTask: 'Finaliser la tâche',
                },
                container: {
                    addItem: 'Ajouter un objet',
                    createContainer: 'Créer un contenant',
                    closeContainer: 'Fermer le contenant',
                    openContainer: 'Ouvrir le contenant',
                    addAccessory: 'Ajouter un accessoire',
                    addContainer: 'Ajouter un contenant',
                    missingLocation: "Attention, ce contenant n'a pas de localisation",
                    addLocation: 'Localiser le contenant',
                    delete: 'Supprimer le contenant',
                },
            },
            addItem: {
                error: {
                    api: "L'item n'a pas pu être ajouté",
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    id: {
                        alreadyAdded: "L'objet est déjà existant dans le mouvement",
                        emptyError: "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        label: 'ID',
                        notFoundError: "L'objet est inconnu",
                    },
                    location: {
                        emptyError: 'Sélectionnez une localisation',
                        label: 'Destination d’arrivée',
                        notFoundError: 'La localisation est inconnue',
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...',
                },
                modal: { title: 'Ajouter un item', shouldChainAdd: 'Saisie à la chaîne' },
            },
            cancelMovement: 'Etes-vous sûr de vouloir annuler ce mouvement ?',
            closeMovement: {
                error: {
                    api: "Le mouvement n'a pas pu être clôturé",
                    network: 'La communication avec le serveur a échoué',
                    noItemLocation: "Démarrage impossible : Un ou plusieurs objets n'ont pas de destination",
                    itemsWithoutPermanentLocation: "Démarrage impossible : Certains objets n'ont pas de localisation permanente.\n Affectez une localisation permanente aux objets concernés ou décochez l'option \"{0}\"",
                    noDestination: "Démarrage impossible : Aucune destination n'est définie pour le mouvement",
                },
                form: {
                    location: {
                        emptyError: 'Veuillez sélectionner une localisation',
                        inputPlaceholder: 'Entrez une localisation',
                        label: "Localisation d'arrivée",
                        noResult: 'Aucun résultat',
                        notFoundError: 'La localisation est inconnue',
                    },
                    permanentLocation: { label: 'Modifier la localisation permanente' },
                    submit: 'Clôturer',
                    submitting: 'Clôture...',
                    usePermanentLocItemAsDestination: {
                        label: 'Utiliser la localisation permanente comme destination',
                    },
                },
                modal: {
                    cannotBeClosed: "Le mouvement n'est pas dans un état permettant d'être clôturé",
                    noItems: "Vous n'avez validé aucun objet",
                    title: 'Clôturer le mouvement',
                },
            },
            createMovementFromTask:
                'Etes-vous sûr de vouloir créer un mouvement à partir de cette tâche ?',
            createReturnMovement:
                'Etes-vous sûr de vouloir créer un mouvement retour à partir de ce mouvement ?',
            confirmation: "Confirmation",
            noItems: "Aucun objet n'est associé",
            chooseItemModal: {
                containerMode: 'Contenant',
                locationMode: 'Localisation',
                containerHint: 'Contenant',
                setPermanentLocation: 'Modifier la localisation permanente',
            },
            mapModal: {
                saveNotification: {
                    locationChanged: "La localisation de l'élement a été changée",
                    containerChanged: "L'élément a été ajouté au contenant",
                    errorMessage: "Une erreur s'est produite",
                },
                locationSelector: 'Ajouter une localisation',
                barcodeEditor: 'Éditer un code-barres',
                editBarcode: 'Éditer',
                editingBarcode: 'Édition',
                generateBarcodePdf: 'Générer le PDF',
                generateBarcodeZpl: 'Générer le ZPL',
            },
            itemTypes: {
                container: 'Contenant',
                museum: 'Objet',
                accessory: 'Accessoire',
                film: 'Film',
            },
            openContainersModal: {
                title: 'Contenants ouverts',
                message:
                    'Le mouvement ne peut pas être fermé car il contient des contenants ouverts :',
                missingLocation:
                    "Certains contenants n'ont pas de localisation  ils ne peuvent pas être fermés",
                closeAll: 'Fermer tous les contenants',
            },
        },
        entityList: {
            actionMenu: { movement: { create: 'Créer un mouvement complexe' } },
            container: {
                deletingConfirmation: 'Êtes-vous sûr de vouloir retirer ce contenant ?',
            },
            movement: {
                createMovement: 'Etes-vous sûr de vouloir créer un mouvement ?',
                featuredEmptyMessage: 'Aucun mouvement',
                featuredTitle: 'Derniers mouvements',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre',
                },
                historyTitle: 'Historique des mouvements',
                deletingConfirmation: 'Êtes-vous sûr de vouloir retirer ce mouvement ?',
            },
            task: {
                featuredEmptyMessage: 'Aucune tâche',
                featuredTitle: 'Dernières tâches',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre',
                },
                historyTitle: 'Historique des tâches',
            },
            seeMore: 'Voir plus',
        },
        firewall: {
            collabWarningMessage:
                "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage:
                "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs",
        },
        featuredCard: {
            authorEmpty: 'Aucun auteur',
            authorError: "Impossible de récuperer l'auteur",
            dateEmpty: 'Pas de date disponible',
            descriptionEmpty: '-',
            headerDateEmpty: 'Pas de date disponible',
            titleEmpty: '-',
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: "L'objet ne peut pas être affiché",
            identifier: 'N° Inv. {identifier}',
            identifierError: "Erreur d'identification",
            location: 'Localisation',
            locationLabel: 'Destination: <strong>{title}</strong>',
            rollback: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
            unknownLocation: 'Inconnue',
            title: 'Titre',
            locationSelector: {
                title: 'Sélectionner une localisation',
                validate: 'Choisir cette localisation',
            },
        },
        linkedMovementLine: {
          linkToMovement: "Accéder au mouvement",
          currentMovement: "Mouvement en cours",
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Motif',
                    motiveMissing: 'Vous devez sélectionner un motif',
                    submit: 'Créer le mouvement',
                    submitting: 'Création...',
                    title: 'Titre du mouvement',
                    titleMissing: 'Vous devez saisir un titre',
                },
                title: 'Nouveau mouvement',
            },
            entity: {
                associatedTask: 'Tâche associée :',
                empty: "Le mouvement ne contient pas d'objet",
            },
            featuredList: { emptyMessage: 'Aucun mouvement disponible', title: 'Mouvements' },
            history: { emptyMessage: 'Aucun movement archivé', title: 'Historique des mouvements' },
            itemCard: {
                arrivalLocation: 'Localisation',
                identifier: "Numéro d'inventaire",
                identifierError: "Erreur d'identification",
                locationHint: 'Localisation habituelle',
                permanentLocation: 'Localisation permanente',
                revertButton: 'Annuler',
                revertPrompt: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
                revertingButton: 'Annulation...',
                state: { finalized: 'Cet item est livré', inTransit: 'Cet item est en transit' },
                deletingConfirmation: 'Êtes-vous sûr de vouloir retirer cet objet ?',
                futureLocation: "Future localisation :",
            },
            state: {
                archived: 'Archivé',
                canceled: 'Annulé',
                finalized: 'Terminé',
                inPreparation: 'En préparation',
                inProgress: 'En cours',
                programmed: 'Planifié',
            },
            items: 'Objets',
            containers: 'Contenants',
            accessories: 'Accessoires',
            addContainerModal: {
              errors: {
                resultsAmongExcludedIds: "Les contenants déjà présents dans le mouvement n'apparaîtront pas ici.",
              },
            },
            addItemModal: {
              errors: {
                resultsAmongExcludedIds: "Les objets déjà présents dans le mouvement n'apparaîtront pas ici.",
              }
            },
        },
        movementItemCard: {
          futureLocation: "Future localisation permanente",
        },
        container: {
            alerts: {
              containerOpened: 'Contenant ouvert !',
              containerClosed: 'Contenant fermé !',
              errors: {
                identificationNumberAlreadyAttributed: "Le numéro d'inventaire est déjà attribué",
              },
            },
            createModal: {
                title: 'Nouveau contenant',
                form: {
                    identifier: 'Identifiant',
                    itemType: "Type d'item",
                    name: 'Nom',
                    location: 'Localisation',
                    chooseLocation: 'Choisir une localisation',
                    submit: 'Créer le contenant',
                },
            },
            itemCard: { deletingConfirmation: 'Voulez-vous retirer cet objet du contenant ?' },
            featuredList: {
                openContainers: {
                    title: 'Contenants ouverts',
                    emptyMessage: 'Aucun contenant ouvert',
                },
                closedContainers: {
                    title: 'Contenants fermés',
                    emptyMessage: 'Aucun contenant fermé',
                },
            },
            containers: 'Contenants',
            items: 'Objets',
            accessories: 'Accessoires',
            validationErrors: {
              identificationNumberAlreadyAttributed: "Valeur déjà attribuée",
            },
            addContainerModal: {
              errors: {
                resultsAmongExcludedIds: "Les contenants déjà présents dans le contenant n'apparaîtront pas ici.",
              },
            },
            addItemModal: {
              errors: {
                resultsAmongExcludedIds: "Les objets déjà présents dans le contenant n'apparaîtront pas ici.",
              }
            },
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour',
                },
                clearCache: {
                    help:
                        "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache',
                },
                overrideLocale: {
                    help:
                        'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise',
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue',
                },
                title: 'Skin-REPORTER',
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?',
        },
        offlineRibbon: { offline: 'Vous êtes hors connexion' },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la resource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré',
            },
        },
        selectItemMultipleForm: {
          errors: {
            resultsAmongExcludedIds: "Les éléments déjà contenus n'apparaîtront pas ici.",
          },
        },
        serviceWorker: {
            updateAvailable:
                "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application",
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Saisissez un commentaire concernant cette tâche...',
                comments: 'Commentaires',
                empty: "La tâche ne contient pas d'objet",
                hasPendingMovement: 'Création du mouvement en cours...',
                comment: { save: 'Sauvegarder' },
            },
            featuredList: { emptyMessage: 'Aucune tâche disponible', title: 'Tâches' },
            history: { emptyMessage: 'Aucune tâche archivée', title: 'Historique des tâches' },
            state: { finalized: 'Terminé', inProgress: 'En cours', planned: 'Planifié' },
        },
        entityHistory: {
            field: { author: 'Auteur', date: 'Clôture', description: 'Titre', title: '#' },
        },
        advanceTask: {
            modal: {
                title: 'Avancer la tâche',
                startTask: 'Voulez-vous vraiment commencer cette tâche ?',
                terminateTask: 'Voulez-vous vraiment finaliser cette tâche ?',
                replanTask: 'Voulez-vous vraiment replanifier cette tâche ?',
            },
        },
        searchFeaturedCard: { institutionLabel: 'Institution' },
    },
    'fr-ca': {
        allItemDisplayList: {
          futureLocation: "Future localisation :",
        },
        countryCode: 'ca',
        actionBar: {
            sideMenu: {
                confirmDeletion: "Confirmer la suppression",
            }
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Les éléments déjà contenus n'apparaîtront pas ici.",
          },
        },
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe',
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur",
                    },
                },
            },
            renew: {
                slowNetwork:
                    "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...',
            },
        },
        dashboard: {
            movement: { title: 'Derniers mouvements', emptyMessage: 'Aucun mouvement' },
            task: { title: 'Dernières tâches', emptyMessage: 'Aucune tâche' },
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Ajouter un objet',
                    cancel: 'Annuler le mouvement',
                    close: 'Clôturer le mouvement',
                    return: 'Créer un mouvement retour',
                    startMovement: 'Lancer le mouvement',
                    addContainer: 'Ajouter un contenant',
                    selectContainer: 'Sélectionner un contenant',
                    addAccessory: 'Ajouter un accessoire',
                    delete: 'Supprimer le mouvement',
                },
                noActions: 'Aucune action possible',
                task: {
                    createComplexMovement: 'Créer un mouvement complexe',
                    createMovement: 'Créer un mouvement depuis cette tâche',
                    createSimpleMovement: 'Créer un mouvement simple',
                    rejectTask: 'Replan la tâche',
                    startTask: 'Démarrer la tâche',
                    terminateTask: 'Finaliser la tâche',
                },
                container: {
                    addItem: 'Ajouter un objet',
                    createContainer: 'Créer un contenant',
                    closeContainer: 'Fermer le contenant',
                    openContainer: 'Ouvrir le contenant',
                    addAccessory: 'Ajouter un accessoire',
                    addContainer: 'Ajouter un contenant',
                    missingLocation: "Attention ce contenant n'a pas de localisation",
                    addLocation: 'Localiser le contenant',
                    delete: 'Supprimer le contenant',
                },
            },
            addItem: {
                error: {
                    api: "L'item n'a pas pu être ajouté",
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    id: {
                        alreadyAdded: "L'objet est déjà existant dans le mouvement",
                        emptyError: "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        label: 'ID',
                        notFoundError: "L'objet est inconnu",
                    },
                    location: {
                        emptyError: 'Sélectionnez une localisation',
                        label: 'Destination d’arrivée',
                        notFoundError: 'La localisation est inconnue',
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...',
                },
                modal: { title: 'Ajouter un item', shouldChainAdd: 'Saisie à la chaîne' },
            },
            cancelMovement: 'Etes-vous sûr de vouloir annuler ce mouvement ?',
            closeMovement: {
                error: {
                    api: "Le mouvement n'a pas pu être clôturé",
                    network: 'La communication avec le serveur a échoué',
                    noItemLocation: "Démarrage impossible : Un ou plusieurs objets n'ont pas de destination",
                    itemsWithoutPermanentLocation: "Démarrage impossible : Certains objets n'ont pas de localisation permanente.\n Affectez une localisation permanente aux objets concernés ou décochez l'option \"{0}\"",
                    noDestination: "Démarrage impossible : Aucune destination n'est définie pour le mouvement",
                },
                form: {
                    location: {
                        emptyError: 'Veuillez sélectionner une localisation',
                        inputPlaceholder: 'Entrez une localisation',
                        label: "Localisation d'arrivée",
                        noResult: 'Aucun résultat',
                        notFoundError: 'La localisation est inconnue',
                    },
                    permanentLocation: { label: 'Modifier la localisation permanente' },
                    submit: 'Clôturer',
                    submitting: 'Clôture...',
                    usePermanentLocItemAsDestination: {
                        label: 'Utiliser la localisation permanente comme destination',
                    },
                },
                modal: {
                    cannotBeClosed: "Le mouvement n'est pas dans un état permettant d'être clôturé",
                    noItems: "Vous n'avez validé aucun objet",
                    title: 'Clôturer le mouvement',
                },
            },
            createMovementFromTask:
                'Etes-vous sûr de vouloir créer un mouvement à partir de cette tâche ?',
            createReturnMovement:
                'Etes-vous sûr de vouloir créer un mouvement retour à partir de ce mouvement ?',
            noItems: "Aucun objet n'est associé",
            chooseItemModal: {
                containerMode: 'Contenant',
                locationMode: 'Localisation',
                containerHint: 'Contenant',
                setPermanentLocation: 'Modifier la localisation permanente',
            },
            confirmation: "Confirmation",
            mapModal: {
                saveNotification: {
                    locationChanged: "La localisation de l'élement a été changée",
                    containerChanged: "L'élément a été ajouté au contenant",
                    errorMessage: "Une erreur s'est produite",
                    itemAlreadyInContainer: "L'objet est déjà présent dans le contenant",
                },
                locationSelector: 'Ajouter une localisation',
                barcodeEditor: 'Éditer un code-barres',
                editBarcode: 'Éditer',
                editingBarcode: 'Édition',
                generateBarcodePdf: 'Générer le PDF',
                generateBarcodeZPL: 'Générer le ZPL',
            },
            itemTypes: {
                container: 'Contenant',
                museum: 'Objet',
                accessory: 'Accessoire',
                film: 'Film',
            },
            openContainersModal: {
                title: 'Contenants ouverts',
                message:
                    'Le mouvement ne peut pas être fermé car il contient des contenants ouverts :',
                missingLocation:
                    "Certains contenants n'ont pas de localisation  ils ne peuvent pas être fermés",
                closeAll: 'Fermer tous les contenants',
            },
        },
        entityList: {
            actionMenu: { movement: { create: 'Créer un mouvement complexe' } },
            container: {
                deletingConfirmation: 'Êtes-vous sûr de vouloir retirer ce contenant ?',
            },
            movement: {
                createMovement: 'Etes-vous sûr de vouloir créer un mouvement ?',
                featuredEmptyMessage: 'Aucun mouvement',
                featuredTitle: 'Derniers mouvements',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre',
                },
                historyTitle: 'Historique des mouvements',
                deletingConfirmation: 'Êtes-vous sûr de vouloir retirer ce mouvement ?',
            },
            task: {
                featuredEmptyMessage: 'Aucune tâche',
                featuredTitle: 'Dernières tâches',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre',
                },
                historyTitle: 'Historique des tâches',
            },
            seeMore: 'Voir plus',
        },
        firewall: {
            collabWarningMessage:
                "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage:
                "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs",
        },
        featuredCard: {
            authorEmpty: 'Aucun auteur',
            authorError: "Impossible de récuperer l'auteur",
            dateEmpty: 'Pas de date disponible',
            descriptionEmpty: '-',
            headerDateEmpty: 'Pas de date disponible',
            titleEmpty: '-',
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: "L'objet ne peut pas être affiché",
            identifier: 'N° Inv. {identifier}',
            identifierError: "Erreur d'identification",
            location: 'Localisation',
            locationLabel: 'Destination: <strong>{title}</strong>',
            rollback: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
            unknownLocation: 'Inconnue',
            title: 'Titre',
            locationSelector: {
                title: 'Sélectionner une localisation',
                validate: 'Choisir cette localisation',
            },
        },
        linkedMovementLine: {
          linkToMovement: "Accéder au mouvement",
          currentMovement: "Mouvement en cours",
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Motif',
                    motiveMissing: 'Vous devez sélectionner un motif',
                    submit: 'Créer le mouvement',
                    submitting: 'Création...',
                    title: 'Titre du mouvement',
                    titleMissing: 'Vous devez saisir un titre',
                },
                title: 'Nouveau mouvement',
            },
            entity: {
                associatedTask: 'Tâche associée :',
                empty: "Le mouvement ne contient pas d'objet",
            },
            featuredList: { emptyMessage: 'Aucun mouvement disponible', title: 'Mouvements' },
            history: { emptyMessage: 'Aucun movement archivé', title: 'Historique des mouvements' },
            itemCard: {
                arrivalLocation: 'Localisation',
                identifier: "Numéro d'inventaire",
                identifierError: "Erreur d'identification",
                locationHint: 'Localisation habituelle',
                permanentLocation: 'Localisation permanente',
                revertButton: 'Annuler',
                revertPrompt: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
                revertingButton: 'Annulation...',
                state: { finalized: 'Cet item est livré', inTransit: 'Cet item est en transit' },
                deletingConfirmation: 'Êtes-vous sûr de vouloir retirer cet objet ?',
                futureLocation: "Future localisation :",
            },
            state: {
                archived: 'Archivé',
                canceled: 'Annulé',
                finalized: 'Terminé',
                inPreparation: 'En préparation',
                inProgress: 'En cours',
                programmed: 'Planifié',
            },
            items: 'Objets',
            containers: 'Contenants',
            accessories: 'Accessoires',
            addContainerModal: {
              errors: {
                resultsAmongExcludedIds: "Les contenants déjà présents dans le mouvement n'apparaîtront pas ici.",
              },
            },
            addItemModal: {
              errors: {
                resultsAmongExcludedIds: "Les objets déjà présents dans le mouvement n'apparaîtront pas ici.",
              }
            },
        },
        movementItemCard: {
          futureLocation: "Future localisation permanente",
        },
        container: {
            alerts: {
              containerOpened: 'Contenant ouvert !',
              containerClosed: 'Contenant fermé !',
              errors: {
                identificationNumberAlreadyAttributed: "Le numéro d'inventaire est déjà attribué",
              },
            },
            createModal: {
                title: 'Nouveau contenant',
                form: {
                    identifier: 'Identifiant',
                    itemType: "Type d'item",
                    name: 'Nom',
                    location: 'Localisation',
                    chooseLocation: 'Choisir une localisation',
                    submit: 'Créer le contenant',
                },
            },
            itemCard: { deletingConfirmation: 'Voulez-vous retirer cet objet du contenant ?' },
            featuredList: {
                openContainers: {
                    title: 'Contenants ouverts',
                    emptyMessage: 'Aucun contenant ouvert',
                },
                closedContainers: {
                    title: 'Contenants fermés',
                    emptyMessage: 'Aucune contenant fermé',
                },
            },
            containers: 'Contenants',
            items: 'Objets',
            accessories: 'Accessoires',
            validationErrors: {
              identificationNumberAlreadyAttributed: "Valeur déjà attribuée",
            },
            addContainerModal: {
              errors: {
                resultsAmongExcludedIds: "Les contenants déjà présents dans le contenant n'apparaîtrons pas ici.",
              },
            },
            addItemModal: {
              errors: {
                resultsAmongExcludedIds: "Les objets déjà présents dans le contenant n'apparaîtrons pas ici.",
              }
            },
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour',
                },
                clearCache: {
                    help:
                        "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache',
                },
                overrideLocale: {
                    help:
                        'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise',
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue',
                },
                title: 'Skin-REPORTER',
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?',
        },
        offlineRibbon: { offline: 'Vous êtes hors connexion' },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la resource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré',
            },
        },
        selectItemMultipleForm: {
          errors: {
            resultsAmongExcludedIds: "Les éléments déjà contenus n'apparaîtront pas ici.",
          },
        },
        serviceWorker: {
            updateAvailable:
                "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application",
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Saisissez un commentaire concernant cette tâche...',
                comments: 'Commentaires',
                empty: "La tâche ne contient pas d'objet",
                hasPendingMovement: 'Création du mouvement en cours...',
                comment: { save: 'Sauvegarder' },
            },
            featuredList: { emptyMessage: 'Aucune tâche disponible', title: 'Tâches' },
            history: { emptyMessage: 'Aucune tâche archivée', title: 'Historique des tâches' },
            state: { finalized: 'Terminé', inProgress: 'En cours', planned: 'Planifié' },
        },
        entityHistory: {
            field: { author: 'Auteur', date: 'Clôture', description: 'Titre', title: '#' },
        },
        advanceTask: {
            modal: {
                title: 'Avancer la tâche',
                startTask: 'Voulez-vous vraiment commencer cette tâche ?',
                terminateTask: 'Voulez-vous vraiment finaliser cette tâche ?',
                replanTask: 'Voulez-vous vraiment replanifier cette tâche ?',
            },
        },
        searchFeaturedCard: { institutionLabel: 'Institution' },
    },
    "nl": {
      allItemDisplayList: {
        futureLocation: "Toekomstige locatie:",
      },
      "actionBar": {
        "sideMenu": {
          "confirmDeletion": "Verwijdering bevestigen"
        }
      },
      addContainerModal: {
        errors: {
          resultsAmongExcludedIds: "Verpakkingen die er al in staan zullen hier niet verschijnen",
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Uw inloggegevens zijn incorrect",
            "network": "Communicatie met server mislukt"
          },
          "form": {
            "password": {
              "error": "Gelieve uw gebruikersnaam in te geven",
              "label": "Paswoord"
            },
            "submit": "Log in",
            "submitting": "Inloggen…",
            "username": {
              "error": "Gelieve uw paswoord in te geven",
              "label": "Gebruikersnaam"
            }
          }
        },
        "renew": {
          "slowNetwork": "Dit lijkt langer te duren dan normaal. Gelieve niet uit te loggen",
          "spinner": "We brengen u terug online"
        }
      },
      "dashboard": {
        "movement": {
          "title": "Laatste verplaatsingen",
          "emptyMessage": "Geen enkele verplaatsing"
        },
        "task": {
          "title": "Laatste taken",
          "emptyMessage": "Geen enkele taak"
        }
      },
      "entity": {
        "actionMenu": {
          "movement": {
            "addItem": "Voeg object toe",
            "cancel": "Annuleer verplaatsing",
            "close": "Rond verplaatsing af",
            "return": "Maak retourverplaatsing aan",
            "startMovement": "Start de verplaatsing",
            "addContainer": "Voeg verpakking toe",
            "selectContainer": "Selecteer verpakking",
            "addAccessory": "Voeg accessoire toe",
            "delete": "Verplaatsing verwijderen"
          },
          "noActions": "Geen enkele actie mogelijk",
          "task": {
            "createComplexMovement": "Maak complexe verplaatsing aan",
            "createMovement": "Maak verplaatsing aan vanaf deze taak",
            "createSimpleMovement": "Maak eenvoudige verplaatsing aan",
            "rejectTask": "Taak opnieuw plannen",
            "startTask": "Start taak",
            "terminateTask": "Rond taak af"
          },
          "container": {
            "addItem": "Voeg object toe",
            "createContainer": "Maak verpakking aan",
            "closeContainer": "Sluit verpakking",
            "openContainer": "Open verpakking",
            "addAccessory": "Voeg accessoire toe",
            "addContainer": "Voeg verpakking toe",
            "missingLocation": "Opgelet, deze verpakking heeft geen locatie",
            "addLocation": "Verpakking lokaliseren",
            "delete": "Container verwijderen"
          }
        },
        "addItem": {
          "error": {
            "api": "Het item kon niet worden toegevoegd",
            "network": "Communicatie met server mislukt"
          },
          "form": {
            "id": {
              "alreadyAdded": "Het object werd reeds toegevoegd aan deze verplaatsing",
              "emptyError": "Gelieve een object te scannen",
              "label": "ID",
              "notFoundError": "Object is onbekend"
            },
            "location": {
              "emptyError": "Gelieve een locatie te selecteren",
              "label": "Aankomstlocatie",
              "notFoundError": "Locatie is onbekend"
            },
            "submit": "Voeg toe",
            "submitting": "Toevoegen…"
          },
          "modal": {
            "title": "Voeg object toe",
            "shouldChainAdd": "Chain adding mogelijk maken"
          }
        },
        "cancelMovement": "Wil u deze verplaatsing annuleren?",
        "closeMovement": {
          "error": {
            "api": "De verplaatsing kon niet worden afgerond",
            "network": "Communicatie met server mislukt",
            "noItemLocation": "Kon niet starten: minstens één item heeft geen aankomstlocatie",
            "itemsWithoutPermanentLocation": "Stel een permanente locatie in voor deze items of vink de optie \"{0}\" uit.",
            "noDestination": "Niet gestart: de aankomstlocatie van de beweging is niet ingesteld."
          },
          "form": {
            "location": {
              "emptyError": "Gelieve een locatie te selecteren",
              "inputPlaceholder": "Gelieve een locatie in te typen",
              "label": "Aankomstlocatie",
              "noResult": "Geen resultaat",
              "notFoundError": "Locatie is onbekend"
            },
            "permanentLocation": {
              "label": "Verander permanente locatie"
            },
            "submit": "Afronden",
            "submitting": "Afronden…",
            "usePermanentLocItemAsDestination": {
              "label": "Gebruik permanente locatie als bestemming"
            }
          },
          "modal": {
            "cannotBeClosed": "De huidige status van de verplaatsing laat geen afronding toe",
            "noItems": "U heeft geen enkel object gevalideerd",
            "title": "De verplaatsing afronden"
          }
        },
        "createMovementFromTask": "Weet u zeker dat u een verplaatsing wil aanmaken, gebaseerd op deze taak?",
        "createReturnMovement": "Weet u zeker dat u een retourverplaatsing wil aanmaken, gebaseerd op deze verplaatsing?",
        "noItems": "Er is geen enkel object gelinkt",
        "chooseItemModal": {
          "containerMode": "Verpakking",
          "locationMode": "Locatie",
          "containerHint": "Verpakking",
          "setPermanentLocation": "Permanente locatie aanpassen"
        },
        confirmation: "Bevestiging",
        "mapModal": {
          "saveNotification": {
            "locationChanged": "De locatie van het item werd gewijzigd",
            "containerChanged": "Het item werd toegevoegd aan de verpakking",
            "errorMessage": "Er is een fout opgetreden",
            "itemAlreadyInContainer": "TRANSLATION IN PROGRESS"
          },
          "locationSelector": "Locatie toevoegen",
          "barcodeEditor": "Barcode bewerken",
          "editBarcod": "TRANSLATION IN PROGRESS",
          "editingBarcode": "Bewerken",
          "editBarcode": "Bewerk",
          "generateBarcodePdf": "PDF genereren",
          "generateBarcodeZpl": "ZPL genereren"
        },
        "itemTypes": {
          "container": "Verpakking",
          "museum": "Object",
          "accessory": "Toebehoren",
          "film": "Film"
        },
        "openContainersModal": {
          "title": "Open verpakking",
          "message": "De verplaatsing kan niet worden afgesloten omdat ze open verpakkingen bevat:",
          "missingLocation": "Sommige verpakkingen hebben geen locatie, ze kunnen niet worden afgesloten",
          "closeAll": "Alle verpakkingen sluiten"
        }
      },
      "entityList": {
        "actionMenu": {
          "movement": {
            "create": "Complexe verplaatsing aanmaken"
          }
        },
        "container": {
          "deletingConfirmation": "Weet je zeker dat je deze container wilt verwijderen?",
          "addItem": "TRANSLATION IN PROGRESS"
        },
        "movement": {
          "createMovement": "Bent u zeker dat u een verplaatsing wil aanmaken?",
          "featuredEmptyMessage": "Geen verplaatsing gevonden",
          "featuredTitle": "Laatste verplaatsingen",
          "field": {
            "author": "Auteur",
            "endDate": "Einddatum",
            "startDate": "Startdatum",
            "title": "Titel"
          },
          "historyTitle": "Historiek van de verplaatsingen",
          "deletingConfirmation": "Weet je zeker dat je deze beweging wilt verwijderen?"
        },
        "task": {
          "featuredEmptyMessage": "Geen taak gevonden",
          "featuredTitle": "Laatste taken",
          "field": {
            "author": "Auteur",
            "endDate": "Einddatum",
            "startDate": "Startdatum",
            "title": "Titel"
          },
          "historyTitle": "Historiek van de taken"
        },
        "seeMore": "Zie meer"
      },
      "firewall": {
        "collabWarningMessage": "Er is geen medewerker gelinkt aan uw account, de toepassing kan minder goed werken",
        "noGroupForUserWarningMessage": "Om SKIN-reporter te kunnen gebruiken moet uw gebruikersaccount gelinkt zijn aan een gebruikersgroep"
      },
      "featuredCard": {
        "authorEmpty": "Geen auteur",
        "authorError": "Niet mogelijk om auteur terug te vinden",
        "dateEmpty": "Geen gegevens beschikbaar",
        "descriptionEmpty": "-",
        "headerDateEmpty": "Geen gegevens beschikbaar",
        "titleEmpty": "-"
      },
      "itemCard": {
        "detailsNotAvailable": "Geen details beschikbaar",
        "error": "Het object kan niet worden getoond",
        "identifier": "Inventarisnummer {identifier}",
        "identifierError": "Identificatiefout",
        "location": "Locatie",
        "locationLabel": "Bestemming: <strong>{title}</strong>",
        "rollback": "Weet u zeker dat u dit object wil resetten?",
        "unknownLocation": "Onbekend",
        "title": "Titel",
        "locationSelector": {
          "title": "Selecteer een locatie",
          "validate": "Kies een locatie"
        }
      },
      linkedMovementLine: {
        linkToMovement: "Toegang tot de beweging",
        currentMovement: "Beweging in uitvoering",
      },
      "movement": {
        "createModal": {
          "form": {
            "motive": "Reden",
            "motiveMissing": "U moet een reden selecteren",
            "submit": "Verplaatsing aanmaken",
            "submitting": "Aanmaken…",
            "title": "Titel van de verplaatsing",
            "titleMissing": "Geef titel van de verplaatsing in"
          },
          "title": "Nieuwe verplaatsing"
        },
        "entity": {
          "associatedTask": "Gelinkte taak:",
          "empty": "De verplaatsing bevat geen object"
        },
        "featuredList": {
          "emptyMessage": "Geen verplaatsing beschikbaar",
          "title": "Verplaatsingen"
        },
        "history": {
          "emptyMessage": "Geen bewaarde verplaatsing",
          "title": "Historiek van de verplaatsingen"
        },
        "itemCard": {
          "arrivalLocation": "Locatie",
          "identifier": "Inventarisnummer ",
          "identifierError": "Identificatiefout",
          "locationHint": "Gebruikelijke locatie",
          "permanentLocation": "Permanente locatie",
          "revertButton": "Annuleer ",
          "revertPrompt": "Weet u zeker dat u dit object wil resetten?",
          "revertingButton": "Annuleren…",
          "state": {
            "finalized": "Dit object is geleverd",
            "inTransit": "Dit object is in transit"
          },
          "deletingConfirmation": "Weet u zeker dat u dit object wil verwijderen?",
          futureLocation: "Toekomstige locatie:",
        },
        "state": {
          "archived": "Gearchiveerd",
          "canceled": "Geannuleerd",
          "finalized": "Voltooid",
          "inPreparation": "In voorbereiding",
          "inProgress": "Lopend",
          "programmed": "Gepland"
        },
        "items": "Objecten",
        "containers": "Verpakkingen",
        "accessories": "Toebehoren",
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Verpakkingen die al in de verplaatsing staan, worden hier niet weergegeven",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Objecten die al in de verplaatsing staan, worden hier niet weergegeven",
          }
        },
      },
      movementItemCard: {
        futureLocation: "Geplande permanente locatie van het object",
      },
      "container": {
        alerts: {
          containerOpened: 'Verpakking geopend !',
          containerClosed: 'Verpakking gesloten !',
          errors: {
            identificationNumberAlreadyAttributed: "Het inventarisnummer is al toegewezen",
          },
        },
        "createModal": {
          "title": "Nieuwe verpakking",
          "form": {
            "identifier": "Identificator",
            itemType: 'Type item',
            "name": "Naam",
            "location": "Locatie",
            "chooseLocation": "Kies een locatie",
            "submit": "Kies verpakking"
          }
        },
        "itemCard": {
          "deletingConfirmation": "Wil u dit object verwijderen uit de verpakking?"
        },
        "featuredList": {
          "openContainers": {
            "title": "Open verpakkingen",
            "emptyMessage": "Geen open verpakkingen"
          },
          "closedContainers": {
            "title": "Gesloten verpakkingen",
            "emptyMessage": "Geen gesloten verpakkingen"
          }
        },
        "containers": "Verpakkingen",
        "items": "Objecten",
        "accessories": "Toebehoren",
        validationErrors: {
          identificationNumberAlreadyAttributed: "Waarde al toegewezen",
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Verpakkingen die al in de Verpakking staan, worden hier niet weergegeven",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Objecten die al in de Verpakking staan, worden hier niet weergegeven",
          }
        },
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Ingebruikname op",
          "checkForUpdate": {
            "help": "Als een update beschikbaar is, zal die automatisch worden geïnstalleerd",
            "title": "Gelieve te checken op updates"
          },
          "clearCache": {
            "help": "Als u offline bent, heeft u niet langer toegang tot de gegevens die zijn opgeslagen op het toestel",
            "title": "Cache legen"
          },
          "overrideLocale": {
            "help": "Het Engels zal worden gebruikt en de instellingen van uw toestel zullen worden genegeerd.",
            "title": "Leg Engelse taal op"
          },
          "resetLocaleOverride": {
            "help": "De taal hangt af van de instellingen van uw toestel",
            "title": "Taal resetten"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Weet u zeker dat u wil uitloggen?"
      },
      "offlineRibbon": {
        "offline": "U bent nu uitgelogd"
      },
      "proxy": {
        "error": {
          "default": "Er is een fout opgetreden in de bron {uri}",
          "network": "Communicatie met server mislukt",
          "notFound": "Bron {uri} niet gevonden",
          "tokenHasExpired": "Sessie is vervallen"
        }
      },
      selectItemMultipleForm: {
        errors: {
          resultsAmongExcludedIds: "Items die er al in staan zullen hier niet verschijnen",
        },
      },
      "serviceWorker": {
        "updateAvailable": "Er werd een update geïnstalleerd. Klik hier om de pagina opnieuw te laden of de toepassing te herstarten."
      },
      "task": {
        "entity": {
          "commentEditorPlaceholder": "Type hier een opmerking over deze taak…",
          "comments": "Opmerkingen",
          "empty": "De taak bevat geen object",
          "hasPendingMovement": "Verplaatsing aan het aanmaken…",
          "comment": {
            "save": "Bewaar"
          }
        },
        "featuredList": {
          "emptyMessage": "Geen enkele taak beschikbaar",
          "title": "Taken"
        },
        "history": {
          "emptyMessage": "Geen gearchiveerde taken",
          "title": "Historiek van de taken"
        },
        "state": {
          "finalized": "Afgerond",
          "inProgress": "Lopend",
          "planned": "Gepland"
        }
      },
      "entityHistory": {
        "field": {
          "author": "Auteur",
          "date": "Sluiten",
          "description": "Titel",
          "title": "#"
        }
      },
      "advanceTask": {
        "modal": {
          "title": "Taak verderzetten",
          "startTask": "Weet u zeker dat u deze taak wil aanvatten?",
          "terminateTask": "Weet u zeker dat u deze taak wil afronden?",
          "replanTask": "Weet u zeker dat u deze taak opnieuw wil plannen?"
        }
      },
      "searchFeaturedCard": {
        "institutionLabel": "Instelling"
      }
    },
    "es": {
      allItemDisplayList: {
        futureLocation: "Futura ubicación :",
      },
      "actionBar": {
        "sideMenu": {
          "confirmDeletion": "Confirmar borrado"
        }
      },
      addContainerModal: {
        errors: {
          resultsAmongExcludedIds: "Los contenedores ya contenidos no aparecerán aquí",
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Sus datos de acceso son incorrectos",
            "network": "La comunicación con el servidor ha fallado"
          },
          "form": {
            "password": {
              "error": "Por favor, introduzca su nombre de usuario",
              "label": "Contraseña"
            },
            "submit": "Entrar en el sistema",
            "submitting": "Conectando...",
            "username": {
              "error": "Por favor, introduzca su contraseña",
              "label": "Nombre de usuario"
            }
          }
        },
        "renew": {
          "slowNetwork": "Si parece que tarda más de lo habitual, no abandones la aplicación.",
          "spinner": "Le reconectamos..."
        }
      },
      "dashboard": {
        "movement": {
          "title": "Últimos movimientos",
          "emptyMessage": "No hay movimiento"
        },
        "task": {
          "title": "Últimas tareas",
          "emptyMessage": "No hay tareas"
        }
      },
      "entity": {
        "actionMenu": {
          "movement": {
            "addItem": "Añadir un objeto",
            "cancel": "Anular el movimiento",
            "close": "Cerrar el movimiento",
            "return": "Crear un movimiento de retorno",
            "startMovement": "Iniciar movimiento",
            "addContainer": "Añadir un contenedor",
            "selectContainer": "Seleccionar un contenedor",
            "addAccessory": "Añadir un accesorio",
            "delete": "Borrar movimiento"
          },
          "noActions": "No hay acción posible",
          "task": {
            "createComplexMovement": "Crear un movimiento complejo",
            "createMovement": "Crear una transacción a partir de esta tarea",
            "createSimpleMovement": "Crear un movimiento sencillo",
            "rejectTask": "Rechazar la tarea",
            "startTask": "Iniciar la tarea",
            "terminateTask": "Finalizar la tarea"
          },
          "container": {
            "addItem": "Añadir un objeto",
            "createContainer": "Crear un contenedor",
            "closeContainer": "Cerrar el contenedor",
            "openContainer": "Abrir el contenedor",
            "addAccessory": "Añadir un accesorio",
            "addContainer": "Añadir un contenedor",
            "missingLocation": "Tenga en cuenta que este contenedor no tiene ubicación",
            "addLocation": "Localizar el contenedor",
            "delete": "Borrar contenedor"
          }
        },
        "addItem": {
          "error": {
            "api": "No se ha podido añadir el objeto",
            "network": "La comunicación con el servidor ha fallado"
          },
          "form": {
            "id": {
              "alreadyAdded": "El objeto ya existe en el movimiento",
              "emptyError": "Por favor, escanee un artículo o introduzca su número de inventario",
              "label": "ID",
              "notFoundError": "El objeto es desconocido"
            },
            "location": {
              "emptyError": "Seleccione una ubicación",
              "label": "Destino de la llegada",
              "notFoundError": "La ubicación es desconocida"
            },
            "submit": "Añadir",
            "submitting": "Añadiendo..."
          },
          "modal": {
            "title": "Añadir un objeto",
            "shouldChainAdd": "Entrada de cadena"
          }
        },
        "cancelMovement": "¿Está seguro de que quiere cancelar este movimiento?",
        "closeMovement": {
          "error": {
            "api": "La transacción no pudo cerrarse",
            "network": "La comunicación con el servidor ha fallado",
            "noItemLocation": "No se puede iniciar: Uno o más objetos no tienen destino",
            "itemsWithoutPermanentLocation": "Asigne una localización permanente a los objetos en cuestión o desmarque la opción \"{0}\".",
            "noDestination": "No se puede iniciar: No se ha definido ningún destino para el movimiento."
          },
          "form": {
            "location": {
              "emptyError": "Seleccione una ubicación",
              "inputPlaceholder": "Introduzca una ubicación",
              "label": "Lugar de llegada",
              "noResult": "No hay resultados",
              "notFoundError": "La ubicación es desconocida"
            },
            "permanentLocation": {
              "label": "Modifique la localización permanente"
            },
            "submit": "Cerrar",
            "submitting": "Cerrando...",
            "usePermanentLocItemAsDestination": {
              "label": "Utilizar la localización permanente como destino"
            }
          },
          "modal": {
            "cannotBeClosed": "La transacción no está en estado de ser cerrada",
            "noItems": "No ha liberado ningún objeto",
            "title": "Cerrar el movimiento"
          }
        },
        "createMovementFromTask": "¿Está seguro de que quiere crear un movimiento a partir de esta tarea?",
        "createReturnMovement": "¿Está seguro de que quiere crear un movimiento de retorno a partir de este movimiento?",
        "noItems": "No hay objeto asociado",
        "chooseItemModal": {
          "containerMode": "Contenedor",
          "locationMode": "Ubicación",
          "containerHint": "Contenedor",
          "setPermanentLocation": "Cambiar ubicación permanente"
        },
        confirmation: "Confirmación",
        "mapModal": {
          "saveNotification": {
            "locationChanged": "Se ha cambiado la ubicación del elemento",
            "containerChanged": "El elemento se ha añadido al contenedor",
            "errorMessage": "Se ha producido un error",
            "itemAlreadyInContainer": "TRANSLATION IN PROGRESS"
          },
          "locationSelector": "Añadir una ubicación",
          "barcodeEditor": "Editar un código de barras",
          "editBarcode": "Editar",
          "editingBarcode": "Edición",
          "generateBarcodePdf": "Generar PDF",
          "generateBarcodeZpl": "Generar ZPL"
        },
        "itemTypes": {
          "container": "Contenedor",
          "museum": "Objeto",
          "accessory": "Accesorio",
          "film": "Película"
        },
        "openContainersModal": {
          "title": "Contenedores abiertos",
          "message": "El movimiento no puede cerrarse porque contiene contenedores abiertos:",
          "missingLocation": "Algunos contenedores no tienen ubicación no se pueden cerrar.",
          "closeAll": "Cierre todos los contenedores"
        }
      },
      "entityList": {
        "actionMenu": {
          "movement": {
            "create": "Crear un movimiento complejo"
          }
        },
        "container": {
          "deletingConfirmation": "¿Está seguro de que desea eliminar este contenedor?"
        },
        "movement": {
          "createMovement": "¿Está seguro de que quiere crear un movimiento?",
          "featuredEmptyMessage": "No hay movimiento",
          "featuredTitle": "Últimos movimientos",
          "field": {
            "author": "Autor",
            "endDate": "Fecha de finalización",
            "startDate": "Fecha de inicio",
            "title": "Título"
          },
          "historyTitle": "Historia del movimiento",
          "deletingConfirmation": "¿Está seguro de que desea eliminar este movimiento?"
        },
        "task": {
          "featuredEmptyMessage": "No hay tarea",
          "featuredTitle": "Últimas tareas",
          "field": {
            "author": "Autor",
            "endDate": "Fecha de finalización",
            "startDate": "Fecha de inicio",
            "title": "Título"
          },
          "historyTitle": "Historial de tareas"
        },
        "seeMore": "Ver más"
      },
      "firewall": {
        "collabWarningMessage": "Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal",
        "noGroupForUserWarningMessage": "El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios"
      },
      "featuredCard": {
        "authorEmpty": "Sin autor",
        "authorError": "Imposible recuperar al autor",
        "dateEmpty": "No hay fecha disponible",
        "descriptionEmpty": "-",
        "headerDateEmpty": "No hay fecha disponible",
        "titleEmpty": "-"
      },
      "itemCard": {
        "detailsNotAvailable": "Detalles no disponibles",
        "error": "El objeto no se puede mostrar",
        "identifier": "Nº de inventario {identificar}",
        "identifierError": "Identificación errónea",
        "location": "Ubicación",
        "locationLabel": "Destino: <strong>{title}</strong>",
        "rollback": "¿Está seguro de que quiere restablecer este elemento?",
        "unknownLocation": "Desconocido",
        "title": "Título",
        "locationSelector": {
          "title": "Seleccione una ubicación",
          "validate": "Elija esta ubicación"
        }
      },
      linkedMovementLine: {
        linkToMovement: "Acceder al movimiento",
        currentMovement: "Movimiento en curso",
      },
      "movement": {
        "createModal": {
          "form": {
            "motive": "Motivo",
            "motiveMissing": "Debe seleccionar un motivo",
            "submit": "Crear el movimiento",
            "submitting": "Creación...",
            "title": "Título del movimiento",
            "titleMissing": "Debe introducir un título"
          },
          "title": "Nuevo movimiento"
        },
        "entity": {
          "associatedTask": "Tarea relacionada:",
          "empty": "La transacción no contiene un objeto"
        },
        "featuredList": {
          "emptyMessage": "No hay movimientos disponibles",
          "title": "Movimientos"
        },
        "history": {
          "emptyMessage": "No hay movimientos archivados",
          "title": "Historia del movimiento"
        },
        "itemCard": {
          "arrivalLocation": "Lugar",
          "identifier": "Número de inventario",
          "identifierError": "Identificación errónea",
          "locationHint": "Ubicación habitual",
          "permanentLocation": "Ubicación permanente",
          "revertButton": "Cancelar",
          "revertPrompt": "¿Está seguro de que quiere restablecer este elemento?",
          "revertingButton": "Cancelación...",
          "state": {
            "finalized": "Este objeto está entregado",
            "inTransit": "Este objeto está en tránsito"
          },
          "deletingConfirmation": "¿Seguro que desea eliminar este objeto?",
          futureLocation: "Futura ubicación :",
        },
        "state": {
          "archived": "Archivado",
          "canceled": "Cancelado",
          "finalized": "Completado",
          "inPreparation": "En preparación",
          "inProgress": "En curso",
          "programmed": "Planificado"
        },
        "items": "Objetos",
        "containers": "Contenedores",
        "accessories": "Accesorios",
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Los contenedores que ya estén en el movimiento no aparecerán aquí",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Los objetos que ya estén en el movimiento no aparecerán aquí",
          }
        },
      },
      movementItemCard: {
        futureLocation: "Futura ubicación permanente",
      },
      "container": {
        alerts: {
          containerOpened: '¡Contenedor abierto!',
          containerClosed: '¡Contenedor cerrado!',
          errors: {
            identificationNumberAlreadyAttributed: "El número de inventario ya ha sido asignado",
          },
        },
        "createModal": {
          "title": "Contenedor nuevo",
          "form": {
            "identifier": "Identificador",
            itemType: 'Tipo de artículo',
            "name": "Nombre",
            "location": "Ubicación",
            "chooseLocation": "Elije una ubicación",
            "submit": "Crear contenedor"
          }
        },
        "itemCard": {
          "deletingConfirmation": "¿Desea eliminar este objeto del contenedor?"
        },
        "featuredList": {
          "openContainers": {
            "title": "Abrir contenedor",
            "emptyMessage": "Ningún contenedor abierto"
          },
          "closedContainers": {
            "title": "Contenedores cerrados",
            "emptyMessage": "No hay contenedores cerrados"
          }
        },
        "containers": "Contenedores",
        "items": "Objetos",
        "accessories": "Accesorios",
        validationErrors: {
          identificationNumberAlreadyAttributed: "Valor ya asignado",
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Los contenedores que ya estén en el contenedor no aparecerán aquí",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Los objetos que ya estén en el contenedor no aparecerán aquí",
          }
        },
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Desplegado en",
          "checkForUpdate": {
            "help": "Si hay una actualización disponible, se instalará automáticamente.",
            "title": "Comprobar las actualizaciones"
          },
          "clearCache": {
            "help": "Si está sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.",
            "title": "Vaciar la caché"
          },
          "overrideLocale": {
            "help": "Se utilizará el idioma inglés y se ignorará la configuración de su terminal.",
            "title": "Forzar el idioma inglés"
          },
          "resetLocaleOverride": {
            "help": "El idioma utilizado dependerá de la configuración de su terminal",
            "title": "Restablecer el idioma"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "¿Está seguro de que quiere desconectarse?"
      },
      "offlineRibbon": {
        "offline": "Usted está fuera de línea"
      },
      "proxy": {
        "error": {
          "default": "Se ha producido un error en el recurso {uri}",
          "network": "La comunicación con el servidor ha fallado",
          "notFound": "No se ha encontrado el recurso {uri}",
          "tokenHasExpired": "Su sesión ha expirado"
        }
      },
      selectItemMultipleForm: {
        errors: {
          resultsAmongExcludedIds: "Los artículos ya contenidos no aparecerán aquí",
        },
      },
      "serviceWorker": {
        "updateAvailable": "Se ha instalado una actualización. Pulse aquí para recargar la página o reiniciar la aplicación"
      },
      "task": {
        "entity": {
          "commentEditorPlaceholder": "Introduzca un comentario sobre esta tarea...",
          "comments": "Comentarios",
          "empty": "La tarea no contiene un objeto",
          "hasPendingMovement": "Creación del movimiento actual...",
          "comment": {
            "save": "Guardar"
          }
        },
        "featuredList": {
          "emptyMessage": "No hay tareas disponibles",
          "title": "Tareas"
        },
        "history": {
          "emptyMessage": "No hay tareas archivadas",
          "title": "Historial de tareas"
        },
        "state": {
          "finalized": "Completado",
          "inProgress": "En curso",
          "planned": "Planificado"
        }
      },
      "entityHistory": {
        "field": {
          "author": "Autor",
          "date": "Cierre",
          "description": "Título",
          "title": "#"
        }
      },
      "advanceTask": {
        "modal": {
          "title": "Avanzar tarea",
          "startTask": "¿Desea iniciar esta tarea?",
          "terminateTask": "¿Está seguro de que desea completar esta tarea?",
          "replanTask": "¿Desea reprogramar esta tarea?"
        }
      },
      "searchFeaturedCard": {
        "institutionLabel": "Institución"
      }
    },
    "it": {
      allItemDisplayList: {
        futureLocation: "Futura sede:",
      },
      "actionBar": {
        "sideMenu": {
          "confirmDeletion": "Confermare l'eliminazione"
        }
      },
      addContainerModal: {
        errors: {
          resultsAmongExcludedIds: "I contenitori già contenuti non appariranno qui",
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Le sue credenziali non sono corrette",
            "network": "La comunicazione con il server è fallita"
          },
          "form": {
            "password": {
              "error": "Inserisca il suo nome utente",
              "label": "La sua password"
            },
            "submit": "Login",
            "submitting": "Accesso...",
            "username": {
              "error": "Inserisca la password",
              "label": "Nome dell' utente"
            }
          }
        },
        "renew": {
          "slowNetwork": "Sembra che ci voglia più tempo del solito, non uscire dall'applicazione.",
          "spinner": "Vi riconnetteremo..."
        }
      },
      "dashboard": {
        "movement": {
          "title": "Ultimi movimenti",
          "emptyMessage": "Nessun movimento"
        },
        "task": {
          "title": "Ultimi compiti",
          "emptyMessage": "Nessun compito"
        }
      },
      "entity": {
        "actionMenu": {
          "movement": {
            "addItem": "Aggiungere un oggetto",
            "cancel": "Annullamento del movimento",
            "close": "Movimento ravvicinato",
            "return": "Creare un movimento di ritorno",
            "startMovement": "Iniziare il movimento",
            "addContainer": "Aggiungere un contenitore",
            "selectContainer": "Selezionare un contenitore",
            "addAccessory": "Aggiungere un accessorio",
            "delete": "Cancellare il movimento"
          },
          "noActions": "Nessuna azione possibile",
          "task": {
            "createComplexMovement": "Creare un movimento complesso",
            "createMovement": "Creare un movimento da questo compito",
            "createSimpleMovement": "Creare un movimento semplice",
            "rejectTask": "Rifiutare il compito",
            "startTask": "Avvio dell'attività",
            "terminateTask": "Terminare il compito"
          },
          "container": {
            "addItem": "Aggiungere un oggetto",
            "createContainer": "Creare un contenitore",
            "closeContainer": "Chiudere il contenitore",
            "openContainer": "Aprire il contenitore",
            "addAccessory": "Aggiungere un accessorio",
            "addContainer": "Aggiungere un contenitore",
            "missingLocation": "Si noti che questo contenitore non ha una localizzazione",
            "addLocation": "Localizzare il contenitore",
            "delete": "Cancellare il contenitore"
          }
        },
        "addItem": {
          "error": {
            "api": "Non è stato possibile aggiungere un oggetto",
            "network": "Comunicazione con il server fallita"
          },
          "form": {
            "id": {
              "alreadyAdded": "L'oggetto esiste già nel movimento",
              "emptyError": "Eseguire la scansione di un oggetto o inserire il numero di inventario.",
              "label": "Numero di inventario",
              "notFoundError": "L'oggetto è sconosciuto"
            },
            "location": {
              "emptyError": "Selezionare una posizione",
              "label": "Destinazione di arrivo",
              "notFoundError": "La posizione è sconosciuta"
            },
            "submit": "Aggiungi",
            "submitting": "Aggiungere un..."
          },
          "modal": {
            "title": "Aggiungere un oggetto",
            "shouldChainAdd": "Ingresso a catena"
          }
        },
        "cancelMovement": "È sicuro di voler annullare questo movimento?",
        "closeMovement": {
          "error": {
            "api": "Non è stato possibile chiudere la transazione",
            "network": "Comunicazione con il server fallita",
            "noItemLocation": "Impossibile iniziare: uno o più oggetti non hanno una destinazione",
            "itemsWithoutPermanentLocation": "Assegnare una posizione permanente agli oggetti interessati o deselezionare l'opzione \"{0}\".",
            "noDestination": "Impossibile iniziare: non è stata definita alcuna destinazione per il movimento."
          },
          "form": {
            "location": {
              "emptyError": "Selezionare una località",
              "inputPlaceholder": "Inserire una posizione",
              "label": "Luogo di arrivo",
              "noResult": "Nessun risultato",
              "notFoundError": "La posizione è sconosciuta"
            },
            "permanentLocation": {
              "label": "Modificare la posizione permanente"
            },
            "submit": "Recinzione",
            "submitting": "Recinzione...",
            "usePermanentLocItemAsDestination": {
              "label": "Utilizzare la posizione permanente come destinazione"
            }
          },
          "modal": {
            "cannotBeClosed": "La transazione non è in grado di essere chiusa.",
            "noItems": "Non avete rilasciato alcun oggetto",
            "title": "Chiudere la transazione"
          }
        },
        "createMovementFromTask": "È sicuro di voler creare un movimento da questo compito?",
        "createReturnMovement": "È sicuro di voler creare una transazione di ritorno da questa transazione?",
        "noItems": "Non è associato alcun oggetto",
        "chooseItemModal": {
          "containerMode": "Contenitore",
          "locationMode": "Posizione",
          "containerHint": "Contenitore",
          "setPermanentLocation": "Modificare la posizione permanente"
        },
        confirmation: "Conferma",
        "mapModal": {
          "saveNotification": {
            "locationChanged": "La locazione dell'oggetto è stata modificata",
            "containerChanged": "L'elemento è stato aggiunto al contenitore",
            "errorMessage": "Si è verificato un errore"
          },
          "locationSelector": "Aggiungere una locazione",
          "barcodeEditor": "Modifica di un codice a barre",
          "editBarcode": "Modificare",
          "editingBarcode": "Modifica",
          "generateBarcodePdf": "Generare PDF",
          "generateBarcodeZpl": "Genera ZPL"
        },
        "itemTypes": {
          "container": "Contenitore",
          "museum": "Oggetto",
          "accessory": "Accessorio",
          "film": "Film"
        },
        "openContainersModal": {
          "title": "Contenitori aperti",
          "message": "Il movimento non può essere chiuso perché contiene contenitori aperti:",
          "missingLocation": "Alcuni contenitori non hanno una posizione e non possono essere chiusi.",
          "closeAll": "Chiudere tutti i contenitori"
        }
      },
      "entityList": {
        "actionMenu": {
          "movement": {
            "create": "Creare un movimento"
          }
        },
        "container": {
          "deletingConfirmation": "Siete sicuri di voler rimuovere questo contenitore?"
        },
        "movement": {
          "createMovement": "È sicuro di voler creare un movimento?",
          "featuredEmptyMessage": "Nessun movimento",
          "featuredTitle": "Ultimi movimenti",
          "field": {
            "author": "Autore",
            "endDate": "Data di fine",
            "startDate": "Data di inizio",
            "title": "Titolo"
          },
          "historyTitle": "Storico dei movimenti",
          "deletingConfirmation": "Siete sicuri di voler rimuovere questo movimento?"
        },
        "task": {
          "featuredEmptyMessage": "Nessun compito",
          "featuredTitle": "Ultimi compiti",
          "field": {
            "author": "Autore",
            "endDate": "Data di fine",
            "startDate": "Data di inizio",
            "title": "Titolo"
          },
          "historyTitle": "Storia dei compiti"
        },
        "seeMore": "Vedi altro"
      },
      "firewall": {
        "collabWarningMessage": "Il suo account non ha un collaboratore associato, l'applicazione potrebbe non funzionare correttamente.",
        "noGroupForUserWarningMessage": "L'uso di SKINreporter richiede che il proprio account utente sia collegato a un gruppo di utenti"
      },
      "featuredCard": {
        "authorEmpty": "Nessun autore",
        "authorError": "Impossibile recuperare l'autore",
        "dateEmpty": "Nessuna data disponibile",
        "descriptionEmpty": "-",
        "headerDateEmpty": "Nessuna data disponibile",
        "titleEmpty": "-"
      },
      "itemCard": {
        "detailsNotAvailable": "Dettagli non disponibili",
        "error": "Non è possibile visualizzare l'oggetto",
        "identifier": "N° Inv. {identifier}",
        "identifierError": "Errore di identificazione",
        "location": "Posizione",
        "locationLabel": "Destinazione : <strong>{titolo}</strong>",
        "rollback": "Si è sicuri di voler ripristinare questo oggetto?",
        "unknownLocation": "Sconosciuta",
        "title": "Titolo",
        "locationSelector": {
          "title": "Selezionare una posizione",
          "validate": "Selezionare questa posizione"
        }
      },
      linkedMovementLine: {
        linkToMovement: "Accedere al movimento",
        currentMovement: "Movimento in corso",
      },
      "movement": {
        "createModal": {
          "form": {
            "motive": "Motivo",
            "motiveMissing": "È necessario selezionare un modello",
            "submit": "Creare il movimento",
            "submitting": "Creare...",
            "title": "Titolo del movimento",
            "titleMissing": "È necessario inserire un titolo"
          },
          "title": "Nuovo movimento"
        },
        "entity": {
          "associatedTask": "Attività associata ",
          "empty": "Il movimento non contiene un oggetto"
        },
        "featuredList": {
          "emptyMessage": "Nessuna transazione disponibile",
          "title": "Movimenti"
        },
        "history": {
          "emptyMessage": "Nessun movimento archiviato",
          "title": "Storia del movimento"
        },
        "itemCard": {
          "arrivalLocation": "Luogo di arrivo",
          "identifier": "Numero di inventario",
          "identifierError": "Errore di identificazione",
          "locationHint": "Posizione abituale",
          "permanentLocation": "Posizione permanente",
          "revertButton": "Annullamento",
          "revertPrompt": "Sei sicuro di voler resettare questo articolo?",
          "revertingButton": "Annullamento...",
          "state": {
            "finalized": "Questo articolo viene consegnato",
            "inTransit": "Questo articolo è in transito"
          },
          "deletingConfirmation": "Sei sicuro di voler rimuovere questo oggetto?",
          futureLocation: "Futura sede:",
        },
        "state": {
          "archived": "Archiviato",
          "canceled": "Annullato",
          "finalized": "Completato",
          "inPreparation": "In preparazione",
          "inProgress": "In corso",
          "programmed": "Pianificato"
        },
        "items": "Oggetti",
        "containers": "Contenitori",
        "accessories": "Accessori",
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "I contenitori già presenti nel movimento non appariranno in questa sezione.",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Gli oggetti già presenti nel movimento non appariranno in questa sezione.",
          }
        },
      },
      movementItemCard: {
        futureLocation: "Futura sede permanente",
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Distribuito su",
          "checkForUpdate": {
            "help": "Se è disponibile un aggiornamento, questo verrà installato automaticamente.",
            "title": "Controlla gli aggiornamenti"
          },
          "clearCache": {
            "help": "Se l'utente è offline, questo rimuove l'accesso a tutti i dati memorizzati sul dispositivo.",
            "title": "Svuotare la cache"
          },
          "overrideLocale": {
            "help": "Verrà utilizzata la lingua inglese e le impostazioni del dispositivo verranno ignorate.",
            "title": "Forzare la lingua inglese"
          },
          "resetLocaleOverride": {
            "help": "La lingua utilizzata dipende dalle impostazioni del dispositivo.",
            "title": "Reimpostare la lingua"
          },
          "title": "Rivelatore di pelle"
        },
        "logout": "È sicuro di volersi scollegare?"
      },
      "offlineRibbon": {
        "offline": "É offline"
      },
      "proxy": {
        "error": {
          "default": "Si è verificato un errore sulla risorsa {uri}.",
          "network": "La comunicazione con il server è fallita",
          "notFound": "La risorsa {uri} non è stata trovata",
          "tokenHasExpired": "La sessione è scaduta"
        }
      },
      selectItemMultipleForm: {
        errors: {
          resultsAmongExcludedIds: "Gli elementi già contenuti non appariranno qui",
        },
      },
      "serviceWorker": {
        "updateAvailable": "È stato installato un aggiornamento. Fare clic qui per ricaricare la pagina o riavviare l'applicazione."
      },
      "task": {
        "entity": {
          "commentEditorPlaceholder": "Inserisci un commento su questa attività...",
          "comments": "Commenti",
          "empty": "Il compito non contiene un oggetto",
          "hasPendingMovement": "Creazione del movimento in corso...",
          "comment": {
            "save": "Salva"
          }
        },
        "featuredList": {
          "emptyMessage": "Nessun compito disponibile",
          "title": "Compiti"
        },
        "history": {
          "emptyMessage": "Nessun compito archiviato",
          "title": "Storia dell'attività"
        },
        "state": {
          "finalized": "Completato",
          "inProgress": "In corso",
          "planned": "Pianificato"
        }
      },
      "entityHistory": {
        "field": {
          "author": "Autore",
          "date": "Chiusura",
          "description": "Titolo",
          "title": "#"
        }
      },
      "container": {
        alerts: {
          containerOpened: 'Contenitore aperto!',
          containerClosed: 'Contenitore chiuso!',
          errors: {
            identificationNumberAlreadyAttributed: "Il numero di inventario è già stato assegnato",
          },
        },
        "createModal": {
          "title": "Nuovo contenitore",
          "form": {
            "identifier": "Identificatore",
            itemType: 'Tipo di articolo',
            "name": "Nome",
            "location": "Posizione",
            "chooseLocation": "Scegliere una posizione",
            "submit": "Creare il contenitore"
          }
        },
        "itemCard": {
          "deletingConfirmation": "Si desidera rimuovere questo oggetto dal contenitore?"
        },
        "featuredList": {
          "openContainers": {
            "title": "Aprire il contenitore",
            "emptyMessage": "Nessun contenitore aperto"
          },
          "closedContainers": {
            "title": "Contenitori chiusi",
            "emptyMessage": "Nessun contenitore chiuso"
          }
        },
        "containers": "Contenitori",
        "items": "Oggetti",
        "accessories": "Accessori",
        validationErrors: {
          identificationNumberAlreadyAttributed: "Valore già assegnato",
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "I contenitori già presenti nel contenitore non appariranno in questa sezione.",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Gli oggetti già presenti nel contenitore non appariranno in questa sezione.",
          }
        },
      },
      "advanceTask": {
        "modal": {
          "title": "Avanzamento dell'attività",
          "startTask": "Volete davvero iniziare questa attività?",
          "terminateTask": "Siete sicuri di voler completare questa attività?",
          "replanTask": "Volete davvero riprogrammare questa attività?"
        }
      },
      "searchFeaturedCard": {
        "institutionLabel": "Istituzione"
      }
    },
    "no": {
      allItemDisplayList: {
        futureLocation: "Fremtidig plassering :",
      },
      "actionBar": {
        "sideMenu": {
          "confirmDeletion": "Bekreft sletting"
        }
      },
      addContainerModal: {
        errors: {
          resultsAmongExcludedIds: "Beholdere som allerede finnes, vises ikke her",
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Påloggingsinformasjonen din er feil",
            "network": "Kommunikasjon med server mislyktes"
          },
          "form": {
            "password": {
              "error": "Vennligst skriv inn din bruker-ID",
              "label": "Passord"
            },
            "submit": "Logg Inn",
            "submitting": "Logger inn",
            "username": {
              "error": "Vennligst skriv inn passordet ditt",
              "label": "bruker-ID"
            }
          }
        },
        "renew": {
          "slowNetwork": "Dette tar litt lengre tid enn vanlig, vennligst ikke logg ut",
          "spinner": "Vi får deg online igjen…"
        }
      },
      "dashboard": {
        "movement": {
          "title": "Siste flyttinger",
          "emptyMessage": "Ingen flytting å behandle"
        },
        "task": {
          "title": "Siste oppgaver",
          "emptyMessage": "Ingen oppgave å behandle"
        }
      },
      "entity": {
        "actionMenu": {
          "movement": {
            "addItem": "Legg til objekt",
            "cancel": "Avbryt flytting",
            "close": "Fullfør flytting",
            "return": "Lag en returflytting",
            "startMovement": "Start bevegelsen",
            "addContainer": "Legg til beholder",
            "selectContainer": "Velg en beholder",
            "addAccessory": "Legg til tilbehør",
            "delete": "Slett bevegelse"
          },
          "noActions": "Ingen handling mulig",
          "task": {
            "createComplexMovement": "Lag en kompleks flytting",
            "createMovement": "Lag en flytting fra denne oppgaven",
            "createSimpleMovement": "Lag en enkel flytting",
            "rejectTask": "Avvis oppgaven",
            "startTask": "Start oppgaven",
            "terminateTask": "Fullfør oppgaven"
          },
          "container": {
            "addItem": "Legg til objekt",
            "createContainer": "Opprett en beholder",
            "closeContainer": "Lukk beholderen",
            "openContainer": "Åpne beholderen",
            "addAccessory": "Legg til tilbehør",
            "addContainer": "Legg til beholder",
            "missingLocation": "Advarsel: Denne beholderen har ikke en plassering",
            "addLocation": "Lokaliser beholderen",
            "delete": "Slett beholder"
          }
        },
        "addItem": {
          "error": {
            "api": "Objektet kunne ikke legges til",
            "network": "Kommunikasjon med server mislyktes"
          },
          "form": {
            "id": {
              "alreadyAdded": "Objektet er allerede lagt til denne flyttingen",
              "emptyError": "Vennligst skann et objekt eller tast inn inventarnummeret",
              "label": "Inventarnummer",
              "notFoundError": "Objektet er ukjent"
            },
            "location": {
              "emptyError": "Vennligst velg et sted",
              "label": "Ankomststed",
              "notFoundError": "Plassering er ukjent"
            },
            "submit": "Legg til",
            "submitting": "Tillegg"
          },
          "modal": {
            "title": "Legg til objekt",
            "shouldChainAdd": "Legge til kjededata"
          }
        },
        "cancelMovement": "Sikker på at du vil avbryte denne flyttingen?",
        "closeMovement": {
          "error": {
            "api": "Flyttingen kunne ikke sluttføres",
            "network": "Kommunikasjon med server mislyktes",
            "noItemLocation": "Kunne ikke starte: Minst ett element har ikke en ankomstplassering",
            "itemsWithoutPermanentLocation": "Angi en permanent plassering for disse varene, eller fjern merket for alternativet \"{0}\".",
            "noDestination": "Startet ikke: Bevegelsens ankomstplassering er ikke angitt."
          },
          "form": {
            "location": {
              "emptyError": "Vennligst velg en plassering",
              "inputPlaceholder": "Vennligst tast inn en plassering",
              "label": "Ankomstplassering",
              "noResult": "Intet resultat",
              "notFoundError": "Plassering ukjent"
            },
            "permanentLocation": {
              "label": "Endre permanent plassering"
            },
            "submit": "Fullfør",
            "submitting": "Fullføres…",
            "usePermanentLocItemAsDestination": {
              "label": "Bruk permanent plassering som destinasjon"
            }
          },
          "modal": {
            "cannotBeClosed": "Flyttingens nåværende status tillater ikke sluttføring",
            "noItems": "Du har ikke validert noe objekt",
            "title": "Fullfør flyttingen"
          }
        },
        "createMovementFromTask": "Vil du lage en flytting basert på denne oppgaven?",
        "createReturnMovement": "Vil du lage en returflytting fra denne flyttingen?",
        "noItems": "Intet objekt er koblet",
        "chooseItemModal": {
          "containerMode": "Beholder",
          "locationMode": "Lokalisering",
          "containerHint": "Beholder",
          "setPermanentLocation": "Angi permanent plassering"
        },
        confirmation: "Bekreftelse",
        "mapModal": {
          "saveNotification": {
            "locationChanged": "Gjenstandens plassering ble endret",
            "containerChanged": "Elementet ble lagt til i beholderen",
            "errorMessage": "Det oppstod en feil ved bruk av endringene"
          },
          "locationSelector": "Legg til plassering",
          "barcodeEditor": "Rediger strekkode",
          "editBarcode": "Redigere",
          "editingBarcode": "Redigering",
          "generateBarcodePdf": "Generer PDF-fil",
          "generateBarcodeZpl": "Generer ZPL"
        },
        "itemTypes": {
          "container": "Beholder",
          "museum": "Gjenstand",
          "accessory": "Tilbehør",
          "film": "Film"
        },
        "openContainersModal": {
          "title": "Åpne beholdere",
          "message": "Flyttingen kan ikke lukkes fordi det er åpne beholdere inni",
          "missingLocation": "Noen beholdere har ikke en plassering og kan derfor ikke lukkes.",
          "closeAll": "Lukk alle beholdere"
        }
      },
      "entityList": {
        "actionMenu": {
          "movement": {
            "create": "Lag en flytting"
          }
        },
        "container": {
          "deletingConfirmation": "Er du sikker på at du vil slette denne beholderen?"
        },
        "movement": {
          "createMovement": "Sikker på at du vil lage en flytting?",
          "featuredEmptyMessage": "Ingen flytting funnet",
          "featuredTitle": "Siste flyttinger",
          "field": {
            "author": "Kunstner",
            "endDate": "Sluttdato",
            "startDate": "Startdato",
            "title": "Tittel"
          },
          "historyTitle": "flyttingshistorikk",
          "deletingConfirmation": "Er du sikker på at du vil slette denne bevegelsen?"
        },
        "task": {
          "featuredEmptyMessage": "Ingen oppgave funnet",
          "featuredTitle": "Siste oppgaver",
          "field": {
            "author": "Kunstner",
            "endDate": "Sluttdato",
            "startDate": "Be om",
            "title": "Tittel"
          },
          "historyTitle": "Oppgavehistorikk"
        },
        "seeMore": "Se mer"
      },
      "firewall": {
        "collabWarningMessage": "Kontoen din har ingen tilhørende samarbeidspartner, det kan hende at appen ikke fungerer",
        "noGroupForUserWarningMessage": "Din brukerkonto må være en del av en brukergruppe for å kunne bruke SKINreporter"
      },
      "featuredCard": {
        "authorEmpty": "Ingen kunstner",
        "authorError": "Umulig å hente kunstneren",
        "dateEmpty": "Ingen dato tilgjengelig",
        "descriptionEmpty": "-",
        "headerDateEmpty": "Ingen dato tilgjengelig",
        "titleEmpty": "-"
      },
      "itemCard": {
        "detailsNotAvailable": "Detaljer ikke tilgjengelige",
        "error": "Gjenstanden kan ikke vises",
        "identifier": "Inventarnummer {identifier}",
        "identifierError": "Identifikasjonsfeil",
        "location": "Plassering",
        "locationLabel": "Destinasjon: <strong>{title}</strong>",
        "rollback": "Vil du tilbakestille objektet?",
        "unknownLocation": "Ukjent",
        "title": "Tittel",
        "locationSelector": {
          "title": "Velg en plassering",
          "validate": "Velg denne plassering"
        }
      },
      linkedMovementLine: {
        linkToMovement: "Få tilgang til bevegelsen",
        currentMovement: "Pågående bevegelse",
      },
      "movement": {
        "createModal": {
          "form": {
            "motive": "Årsak til flytting",
            "motiveMissing": "Velg årsak til flytting",
            "submit": "Lag flytting",
            "submitting": "Lager flytting",
            "title": "Tittel på flytting",
            "titleMissing": "Skriv inn tittelen på flyttingen"
          },
          "title": "Ny flytting"
        },
        "entity": {
          "associatedTask": "Tilhørende oppgave:",
          "empty": "Denne flyttingen inneholder intet objekt"
        },
        "featuredList": {
          "emptyMessage": "Ingen flytting tilgjengelig",
          "title": "Flyttinger"
        },
        "history": {
          "emptyMessage": "Ingen lagret flytting",
          "title": "Flyttingshistorikk"
        },
        "itemCard": {
          "arrivalLocation": "Ankomstplassering",
          "identifier": "Inventarnummer",
          "identifierError": "Identifikasjonsfeil",
          "locationHint": "Vanlig plassering",
          "permanentLocation": "Permanent plassering",
          "revertButton": "Avbryt",
          "revertPrompt": "Er du sikker på at du vil starte objektet på nytt?",
          "revertingButton": "Avbryter",
          "state": {
            "finalized": "Objektet er levert",
            "inTransit": "Objektet er i transitt"
          },
          "deletingConfirmation": "Er du sikker på at du vil slette dette objektet?",
          futureLocation: "Fremtidig plassering :",
        },
        "state": {
          "archived": "Arkivert",
          "canceled": "Kansellert",
          "finalized": "Fullført",
          "inPreparation": "Under forberedelse",
          "inProgress": "Pågår…",
          "programmed": "Planlagt"
        },
        "items": "Objekter",
        "containers": "Beholdere",
        "accessories": "Tilbehør",
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Beholdere som allerede finnes i flytting, vises ikke her.",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Objekter som allerede finnes i flytting, vises ikke her.",
          }
        },
      },
      movementItemCard: {
        futureLocation: "Fremtidig permanent plassering",
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Utplassert den",
          "checkForUpdate": {
            "help": "Hvis en oppdatering er tilgjengelig, vil den  installeres automatisk",
            "title": "Vennligst sjekk oppdateringer"
          },
          "clearCache": {
            "help": "Hvis du er frakoblet, vil det blokkere tilgangen til alle dataene som er lagret på enheten",
            "title": "Tøm hurtigbufferminnet"
          },
          "overrideLocale": {
            "help": "Engelsk språk vil bli brukt, og overstyrer enhetens innstillinger",
            "title": "Overstyr lokalspråket med engelsk"
          },
          "resetLocaleOverride": {
            "help": "Språket som brukes vil avhenge av enhetens innstillinger",
            "title": "Tilbakestill overstyring av lokalspråket"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Sikker på at du vil logge ut?"
      },
      "offlineRibbon": {
        "offline": "Du er nå logget ut"
      },
      "proxy": {
        "error": {
          "default": "Det oppsto en feil på ressursen {uri}",
          "network": "Kommunikasjon med serveren mislyktes",
          "notFound": "Finner ikke ressursen {uri}",
          "tokenHasExpired": "Økten er utløpt"
        }
      },
      selectItemMultipleForm: {
        errors: {
          resultsAmongExcludedIds: "Elementer som allerede finnes, vises ikke her",
        },
      },
      "serviceWorker": {
        "updateAvailable": "En oppdatering er installert. Klikk her for å oppdatere siden eller starte applikasjonen på nytt"
      },
      "task": {
        "entity": {
          "commentEditorPlaceholder": "Skriv et kommentar om oppgaven her...",
          "comments": "Kommentarer",
          "empty": "Det er intet objekt knyttet til denne oppgaven",
          "hasPendingMovement": "Oppretting av flyttingen pågår...",
          "comment": {
            "save": "Lagre"
          }
        },
        "featuredList": {
          "emptyMessage": "Ingen oppgave tilgjengelig",
          "title": "Oppgaver"
        },
        "history": {
          "emptyMessage": "Ingen arkiverte oppgaver",
          "title": "Oppgavehistorikk"
        },
        "state": {
          "finalized": "Fullført",
          "inProgress": "Pågår",
          "planned": "Planlagt"
        }
      },
      "entityHistory": {
        "field": {
          "author": "Kunstner",
          "date": "Lukking",
          "description": "Tittel",
          "title": "#"
        }
      },
      "container": {
        alerts: {
          containerOpened: 'Beholderen er åpnet!',
          containerClosed: 'Beholderen er lukket!',
          errors: {
            identificationNumberAlreadyAttributed: "Inventarnummeret er allerede tildelt",
          },
        },
        "createModal": {
          "title": "Ny beholder",
          "form": {
            "identifier": "Identifikator",
            itemType: 'Type artikkel',
            "name": "Navn",
            "location": "Plassering",
            "chooseLocation": "Velg plassering",
            "submit": "Opprett beholder"
          }
        },
        "itemCard": {
          "deletingConfirmation": "Vil du fjerne dette elementet fra beholderen?"
        },
        "featuredList": {
          "openContainers": {
            "title": "Åpne beholdere",
            "emptyMessage": "Ingen åpne beholdere"
          },
          "closedContainers": {
            "title": "Lukkede beholdere",
            "emptyMessage": "Ingen lukkede beholdere"
          }
        },
        "containers": "Beholdere",
        "items": "Gjenstander",
        "accessories": "Tilbehør",
        validationErrors: {
          identificationNumberAlreadyAttributed: "Verdi allerede tildelt",
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Beholdere som allerede finnes i beholderen, vises ikke her.",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Objekter som allerede finnes i beholderen, vises ikke her.",
          }
        },
      },
      "advanceTask": {
        "modal": {
          "title": "Gå videre med oppgaven",
          "startTask": "Er du sikker på at du ønsker å starte denne oppgaven?",
          "terminateTask": "Er du sikker på at du ønsker å fullføre denne oppgaven?",
          "replanTask": "Er du sikker på at du ønsker å planlegge denne oppgaven på nytt?"
        }
      },
      "searchFeaturedCard": {
        "institutionLabel": "Institusjon"
      }
    },
    "de": {
      allItemDisplayList: {
        futureLocation: "Zukünftiger Standort :",
      },
      "actionBar": {
        "sideMenu": {
          "confirmDeletion": "Bestätigen Sie die Löschung"
        }
      },
      addContainerModal: {
        errors: {
          resultsAmongExcludedIds: "Bereits enthaltene Container werden hier nicht angezeigt.",
        },
      },
      "entity": {
        "actionMenu": {
          "movement": {
            "startMovement": "Starten Sie die Bewegung",
            "addContainer": "einen Behälter hinzufügen",
            "selectContainer": "einen Behälter auswählen",
            "addAccessory": "ein Zubehör hinzufügen",
            "addItem": "ein Objekt hinzufügen",
            "cancel": "die Objektbewegung abbrechen",
            "close": "die Objektbewegung abschlieẞen",
            "return": "eine Objektrückkehr erstellen",
            "delete": "Bewegung löschen"
          },
          "task": {
            "terminateTask": "eine Aufgabe abschlieẞen",
            "createComplexMovement": "eine komplexe Objektbewegung erstellen",
            "createMovement": "eine Objektbewegung aus diesem Auftrag heraus erstellen",
            "createSimpleMovement": "eine einfache Objektbewegung erstellen",
            "rejectTask": "den Auftrag neuplanen",
            "startTask": "Auftrag starten"
          },
          "container": {
            "addItem": "ein Objekt hinzufügen",
            "createContainer": "einen Behälter herstellen",
            "closeContainer": "den Behälter schlieẞen",
            "openContainer": "den Behälter öffnen",
            "addAccessory": "ein Zubehör hinzufügen",
            "addContainer": "einen Behälter hinzufügen",
            "missingLocation": "Achtung, dieser Behälter hat keinen Standort",
            "addLocation": "den Behälter lokalisieren",
            "delete": "Behälter löschen"
          },
          "noActions": "keine Maẞnahme möglich"
        },
        "addItem": {
          "modal": {
            "shouldChainAdd": "serienmäẞige Eingabe",
            "title": "ein Einzelstück hinzufügen"
          },
          "error": {
            "api": "das Einzelstück konnte nicht hinzugefügt werden",
            "network": "Verbindung zum Server ist fehlgeschlagen"
          },
          "form": {
            "id": {
              "alreadyAdded": "das Objekt ist bereits in der Bewegung vorhanden",
              "emptyError": "Bitte scannen sie ein Objekt oder geben seine Inventarnummer ein",
              "label": "ID",
              "notFoundError": "das Objekt ist unbekannt"
            },
            "location": {
              "emptyError": "einen Objektstandort auswählen",
              "label": "Bestimmungsort",
              "notFoundError": "der Standort ist unbekannt"
            },
            "submit": "hinzufügen",
            "submitting": "Hinzufügung"
          }
        },
        "closeMovement": {
          "error": {
            "api": "die Objektbewegung konnte nicht abgeschlossen werden",
            "network": "Verbindung zum Server ist fehlgeschlagen",
            "noItemLocation": "Start unmöglich: Ein oder mehrere Objekt(e) haben keinen Bestimmungsort. ",
            "itemsWithoutPermanentLocation": "Bitte legen Sie für diese Positionen einen festen Standort fest oder deaktivieren Sie die Option \"{0}\".",
            "noDestination": "Start fehlgeschlagen: Der Zielort der Bewegung ist nicht festgelegt."
          },
          "form": {
            "location": {
              "emptyError": "wählen sie einen Standort aus",
              "inputPlaceholder": "geben sie einen Standort ein",
              "label": "Bestimmungsstandort",
              "noResult": "kein Ergebnis",
              "notFoundError": "der Standort ist unbekannt"
            },
            "permanentLocation": {
              "label": "Permanenten Standort ändern"
            },
            "submit": "abschlieẞen",
            "submitting": "Abschluss",
            "usePermanentLocItemAsDestination": {
              "label": "Ständigen Standort als Zielort verwenden"
            }
          },
          "modal": {
            "cannotBeClosed": "Die Objektbewegung befindet sich in einem Status, der ein Abschlieẞen unmöglich macht",
            "noItems": "Sie haben kein Objekt bestätigt",
            "title": "die Objektbewegung abschlieẞen"
          }
        },
        "chooseItemModal": {
          "containerMode": "Behälter",
          "locationMode": "Lokalisierung",
          "containerHint": "Behälter",
          "setPermanentLocation": "Änderung des permanenten Standorts"
        },
        "mapModal": {
          "saveNotification": {
            "locationChanged": "Der Standort des Elements wurde geändert.",
            "containerChanged": "Das Element wurde dem Behälter hinzugefügt",
            "errorMessage": "ein Fehler ist aufgetreten"
          },
          "locationSelector": "einen Standort hinzufügen",
          "barcodeEditor": "einen Barcode editieren",
          "editBarcode": "editieren",
          "editingBarcode": "bearbeiten",
          "generateBarcodePdf": "PDF generieren",
          "generateBarcodeZpl": "ZPL generieren"
        },
        "itemTypes": {
          "container": "Behälter",
          "museum": "Objekt",
          "accessory": "Zubehör",
          "film": "Film"
        },
        "openContainersModal": {
          "title": "offene Behälter",
          "message": "Die Verlagerung kann nicht abgeschlossen werden, aufgrund veschiedener offener Behälter :",
          "missingLocation": "Bestimmte Behälter sind ohne ausgewiesenen Standort, sie können nicht verschlossen werden.",
          "closeAll": "Alle Behälter verschlieẞen"
        },
        "cancelMovement": "Sind sie sicher, diese Objektbewegung abbrechen zu wollen ?",
        "createMovementFromTask": "Sind sie sicher, eine Objektbewegung aus diesem Auftrag heraus erstellen zu wollen?",
        "createReturnMovement": "Sind sie sicher, eine Objektrückkehr aus dieser Bewegung heraus erstellen zu wollen?",
        confirmation: "Konfirmation",
        "noItems": "kein verknüpftes Objekt"
      },
      "entityList": {
        "actionMenu": {
          "movement": {
            "create": "eine komplexe Verlagerung erstellen"
          }
        },
        "container": {
          "deletingConfirmation": "Sind Sie sicher, dass Sie diesen Behälter löschen wollen?"
        },
        "seeMore": "mehr anzeigen",
        "movement": {
          "createMovement": "Sind sie sicher, eine Objektbewegung erstellen zu wollen?",
          "featuredEmptyMessage": "keine Objektbewegung",
          "featuredTitle": "letzte Objektbewegungen",
          "field": {
            "author": "Autor",
            "endDate": "Enddatum",
            "startDate": "Beginndatum",
            "title": "Titel"
          },
          "historyTitle": "Historie der Objektbewegungen",
          "deletingConfirmation": "Sind Sie sicher, dass Sie diese Bewegung löschen wollen?"
        },
        "task": {
          "featuredEmptyMessage": "kein Auftrag",
          "featuredTitle": "letzte Aufträge",
          "field": {
            "author": "Autor",
            "endDate": "Enddatum",
            "startDate": "Beginndatum",
            "title": "Titel"
          },
          "historyTitle": "Historie der Aufträge"
        }
      },
      linkedMovementLine: {
        linkToMovement: "Zur Bewegung gehen",
        currentMovement: "Laufende Bewegung",
      },
      "movement": {
        "itemCard": {
          "deletingConfirmation": "Möchten sie dieses Objekt wirklich zurücknehmen ?",
          "arrivalLocation": "Standort",
          "identifier": "Inv.-Nr.",
          "identifierError": "Identifikationsfehler",
          "locationHint": "gewöhnlicher Standort",
          "permanentLocation": "Permanenter Standort",
          "revertButton": "abbrechen",
          "revertPrompt": "Sind sie sicher, dieses Objekt reinitialisieren zu wollen?",
          "revertingButton": "Abbrechen",
          "state": {
            "finalized": "dieses Objekt ist geliefert",
            "inTransit": "dieses Objekt befindet sich im Transit"
          },
          futureLocation: "Zukünftiger Standort :",
        },
        "items": "Objekte",
        "containers": "Behälter",
        "accessories": "Zubehör",
        "createModal": {
          "form": {
            "motive": "Grund",
            "motiveMissing": "sie müssen einen Grund auswählen",
            "submit": "eine Objektbewegung erstellen",
            "submitting": "Erstellung",
            "title": "Titel der Objektbewegung",
            "titleMissing": "Sie müssen einen Titel eingeben"
          },
          "title": "neue Objektbewegung"
        },
        "entity": {
          "associatedTask": "verknüpfter Auftrag:",
          "empty": "die Bewegung enthält kein Objekt"
        },
        "featuredList": {
          "emptyMessage": "Keine Bewegung verfügbar",
          "title": "Objektbewegungen"
        },
        "history": {
          "emptyMessage": "keine Bewegung archiviert",
          "title": "Historie der Objektbewegungen"
        },
        "state": {
          "archived": "archiviert",
          "canceled": "annulliert",
          "finalized": "beendet",
          "inPreparation": "in Vorbereitung",
          "inProgress": "in Bearbeitung",
          "programmed": "geplant"
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Behälter, die sich bereits im Bewegung befinden, werden hier nicht angezeigt.",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Objekte, die sich bereits im Bewegung befinden, werden hier nicht angezeigt.",
          }
        },
      },
      movementItemCard: {
        futureLocation: "Zukünftiger permanenter Standort",
      },
      "container": {
        alerts: {
          containerOpened: 'Behälter geöffnet !',
          containerClosed: 'Behälter geschlossen !',
          errors: {
            identificationNumberAlreadyAttributed: "Die Inventarnummer ist bereits vergeben",
          },
        },
        "createModal": {
          "title": "neuer Behälter",
          "form": {
            "identifier": "Kennzeichnung",
            itemType: 'Art des Items',
            "name": "Name",
            "location": "Lokalisierung",
            "chooseLocation": "einen Standort auswählen",
            "submit": "den Behälter herstellen"
          }
        },
        "itemCard": {
          "deletingConfirmation": "Möchten sie dieses Objekt aus dem Behälter entnehmen ?"
        },
        "featuredList": {
          "openContainers": {
            "title": "offene Behälter",
            "emptyMessage": "kein einziger offener Behälter"
          },
          "closedContainers": {
            "title": "geschlossene Behälter",
            "emptyMessage": "kein einziger geschlossener Behälter"
          }
        },
        "containers": "Behälter",
        "items": "Objekte",
        "accessories": "Zubehör",
        validationErrors: {
          identificationNumberAlreadyAttributed: "Bereits vergebener Wert",
        },
        addContainerModal: {
          errors: {
            resultsAmongExcludedIds: "Behälter, die sich bereits im Behälter befinden, werden hier nicht angezeigt.",
          },
        },
        addItemModal: {
          errors: {
            resultsAmongExcludedIds: "Objekte, die sich bereits im Behälter befinden, werden hier nicht angezeigt.",
          }
        },
      },
      "task": {
        "entity": {
          "comment": {
            "save": "speichern"
          },
          "commentEditorPlaceholder": "Geben Sie einen Kommentar zu diesem Auftrag ein…",
          "comments": "Kommentare",
          "empty": "Der Auftrag enthält kein Objekt",
          "hasPendingMovement": "Erstellung einer Objektbewegung in Bearbeitung"
        },
        "featuredList": {
          "emptyMessage": "kein Auftrag verfügbar",
          "title": "Aufträge"
        },
        "history": {
          "emptyMessage": "kein Auftrag archiviert",
          "title": "Historie der Aufträge"
        },
        "state": {
          "finalized": "beendet",
          "inProgress": "in Bearbeitung",
          "planned": "geplant"
        }
      },
      "advanceTask": {
        "modal": {
          "title": "Aufgabe voranbringen",
          "startTask": "Möchten sie diese Aufgabe wirklich beginnen ?",
          "terminateTask": "Möchten sie diese Aufgabe wirklich abschlieẞen ?",
          "replanTask": "Möchten sie diese Aufgabe wirklich neuplanen ?"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "ihr(e) Benutzername(n) sind fehlerhaft",
            "network": "Verbindung zum Server ist fehlgeschlagen"
          },
          "form": {
            "password": {
              "error": "Bitte geben sie ihren Benutzernamen ein",
              "label": "Passwort"
            },
            "submit": "sich anmelden",
            "submitting": "Verbindungsaufbau…",
            "username": {
              "error": "Bitte geben sie ihr Passwort ein",
              "label": "Benutzername"
            }
          }
        },
        "renew": {
          "slowNetwork": "Der Vorgang dauert länger als gewöhnlich, bitte verlassen sie die App nicht",
          "spinner": "Wir verbinden sie neu"
        }
      },
      "dashboard": {
        "movement": {
          "title": "letzte Objektbewegungen",
          "emptyMessage": "keine Objektbewegung"
        },
        "task": {
          "title": "letzte Aufträge",
          "emptyMessage": "kein Auftrag"
        }
      },
      "firewall": {
        "collabWarningMessage": "Ihr Konto hat keinen assoziierten Mitarbeiter, die App kann nicht funktionieren",
        "noGroupForUserWarningMessage": "Die Nutzung von SKINreporter erfordert, dass ihr Benutzerkonto mit einer Benutzergruppe verknüpft ist"
      },
      "featuredCard": {
        "authorEmpty": "kein Autor",
        "authorError": "der Autor ist nicht abrufbar",
        "dateEmpty": "kein Datum abrufbar",
        "descriptionEmpty": "-",
        "headerDateEmpty": "kein Datum abrufbar",
        "titleEmpty": "-"
      },
      "itemCard": {
        "detailsNotAvailable": "Details nicht verfügbar",
        "error": "das Objekt kann nicht angezeigt werden",
        "identifier": "Inv.-Nr.  {identifier}",
        "identifierError": "Identifikationsfehler",
        "location": "Standort",
        "locationLabel": "Bestimmung: <strong>{title}</strong>",
        "rollback": "Sind sie sicher, dieses Objekt reinitialisieren zu wollen?",
        "unknownLocation": "Unbekannt",
        "title": "Titel",
        "locationSelector": {
          "title": "einen Standort auswählen",
          "validate": "diesen Standort wählen"
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "eingesetzt am",
          "checkForUpdate": {
            "help": "Sollte ein Update verfügbar sein, wird es automatisch installiert.",
            "title": "überprüfen sie die Updates"
          },
          "clearCache": {
            "help": "Wenn Sie offline sind, wird dadurch der Zugriff auf alle auf dem Gerät gespeicherten Daten gelöscht",
            "title": "den Cache leeren"
          },
          "overrideLocale": {
            "help": "Es wird die englische Sprache verwendet werden und die Einstellungen ihres Endgeräts übergegangen",
            "title": "die englische Sprache erzwingen"
          },
          "resetLocaleOverride": {
            "help": "Die verwendete Sprache hängt von den Einstellungen ihres Endgeräts ab",
            "title": "Sprache reinitialisieren"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Sind sie sicher, sich abmelden zu wollen?"
      },
      "offlineRibbon": {
        "offline": "Sie sind offline"
      },
      "proxy": {
        "error": {
          "default": "bezüglich der Ressource {uri} ist ein Fehler aufgetreten",
          "network": "Verbindung zum Server ist fehlgeschlagen",
          "notFound": "Die Ressource  {uri} wurde nicht gefunden",
          "tokenHasExpired": "Ihre Session ist abgelaufen"
        }
      },
      selectItemMultipleForm: {
        errors: {
          resultsAmongExcludedIds: "Bereits enthaltene Objekte werden hier nicht angezeigt.",
        },
      },
      "serviceWorker": {
        "updateAvailable": "Es wurde ein Update installiert. Klicken Sie hier, um die Seite neu zu laden oder starten Sie die Anwendung neu."
      },
      "entityHistory": {
        "field": {
          "author": "Autor",
          "date": "Abschluss",
          "description": "Titel",
          "title": "#"
        }
      },
      "searchFeaturedCard": {
        "institutionLabel": "Einrichtung"
      }
    },
}

export const dateTimeFormats = {
    fr: {
        short: {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
        shortTime: {
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            month: '2-digit',
            second: 'numeric',
            year: 'numeric',
        },
        year: {
            year: 'numeric',
        },
    },
}
